var _style, _g, _path, _path2, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs0, _defs1, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _g2, _path3, _path4, _path5, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{opacity:0.687;fill:#D8ED37;enable-background:new    ;}\n\t.st3{opacity:0.708;fill:#0CCE92;enable-background:new    ;}\n\t.st4{clip-path:url(#SVGID_00000164503187200043190400000007687716069671025039_);}\n\t.st5{clip-path:url(#SVGID_00000016796719696199212410000009787983130022672778_);}\n\t.st6{clip-path:url(#SVGID_00000128467872845168278160000006418928005629965236_);}\n\t.st7{clip-path:url(#SVGID_00000130616468059259403510000000620453232183795079_);}\n\t.st8{clip-path:url(#SVGID_00000109004652415753461600000005079407403507964802_);}\n\t.st9{clip-path:url(#SVGID_00000147209775968942516370000008204496262544274337_);}\n\t.st10{clip-path:url(#SVGID_00000017497001656545222550000007077056959730686641_);}\n\t.st11{clip-path:url(#SVGID_00000154400576535988847790000006103784026492563633_);}\n\t.st12{clip-path:url(#SVGID_00000100382639184982178990000001281127244103985575_);}\n\t.st13{clip-path:url(#SVGID_00000138548932802902150170000010665728820311872429_);}\n\t.st14{clip-path:url(#SVGID_00000134220510029399107570000009412962487804890252_);}\n\t.st15{clip-path:url(#SVGID_00000038373072239169869990000003154177695639926200_);}\n\t.st16{clip-path:url(#SVGID_00000053518173184836521310000012463082616282306188_);}\n\t.st17{clip-path:url(#SVGID_00000009558386010539605270000004595527185980485298_);}\n\t.st18{clip-path:url(#SVGID_00000145051795431570900800000003425277891343633818_);}\n\t.st19{clip-path:url(#SVGID_00000171705115792532185460000010947669474065635975_);}\n\t.st20{clip-path:url(#SVGID_00000081627515038006060330000004015963948350100376_);}\n\t.st21{clip-path:url(#SVGID_00000119075943097116884820000000601411348467987642_);}\n\t.st22{clip-path:url(#SVGID_00000170243773579275414980000004454461555063177654_);}\n\t.st23{clip-path:url(#SVGID_00000039822614750719209120000009729885013895299223_);}\n\t.st24{clip-path:url(#SVGID_00000051385382907797534120000013408189427498302090_);}\n\t.st25{clip-path:url(#SVGID_00000047776996010638102020000009638623533977472173_);}\n\t.st26{clip-path:url(#SVGID_00000017491728219803180170000011859343370987778475_);}\n\t.st27{clip-path:url(#SVGID_00000082359578731049816000000011726416267425887621_);}\n\t.st28{clip-path:url(#SVGID_00000023261436654549167580000008003899787045461678_);}\n\t.st29{clip-path:url(#SVGID_00000072276031026318547260000007800052610144607657_);}\n\t.st30{clip-path:url(#SVGID_00000016790855741170383360000004568877253035447186_);}\n\t.st31{clip-path:url(#SVGID_00000149366540417900290340000017989775387211696263_);}\n\t.st32{clip-path:url(#SVGID_00000067937313172032337110000017925804487073178497_);}\n\t.st33{clip-path:url(#SVGID_00000034052576439269770610000003416825452065901697_);}\n\t.st34{fill:#302C0B;}\n\t.st35{display:inline;fill:#302C0B;}\n\t.st36{display:inline;opacity:0.7;fill:url(#SVGID_00000036222172058380125750000011387854243291704489_);}\n\t.st37{display:inline;opacity:0.7;fill:url(#SVGID_00000100359078101230633880000018440705278007733678_);}\n\t.st38{display:inline;opacity:0.7;fill:url(#SVGID_00000116196454327429538350000014328031388867279545_);}\n\t.st39{display:inline;opacity:0.7;fill:url(#SVGID_00000132793531960468045720000014475022806348379291_);}\n\t.st40{display:inline;opacity:0.7;fill:url(#SVGID_00000174579918894320046680000000781120495501514683_);}\n\t.st41{display:inline;opacity:0.7;fill:url(#SVGID_00000096023666506075234520000012435963174378159803_);}\n\t.st42{display:inline;opacity:0.7;fill:url(#SVGID_00000117665768602405864660000013761392484494572457_);}\n\t.st43{display:inline;opacity:0.8;fill:url(#SVGID_00000173151034901339095200000007763112155365535166_);}\n\t.st44{display:inline;opacity:0.7;fill:url(#SVGID_00000039118096820340868050000001472879713303046324_);}\n\t.st45{display:inline;opacity:0.7;fill:url(#SVGID_00000006703448628679354710000017650385739893364671_);}\n\t.st46{display:inline;opacity:0.7;fill:url(#SVGID_00000163789597835346446300000004171374482075798173_);}\n\t.st47{display:inline;opacity:0.7;fill:url(#SVGID_00000023999392799043781220000001058087332045940625_);}\n\t.st48{display:inline;opacity:0.7;fill:url(#SVGID_00000101819824101293678670000003412190506380966818_);}\n\t.st49{display:inline;opacity:0.7;fill:url(#SVGID_00000133514791646038623180000001976727937931304116_);}\n\t.st50{display:inline;opacity:0.7;fill:url(#SVGID_00000139257510650728979420000009915850914855896488_);}\n\t.st51{display:inline;opacity:0.7;fill:url(#SVGID_00000124151010181846348610000016871063378977867426_);}\n\t.st52{display:inline;opacity:0.7;fill:url(#SVGID_00000062914032197778702770000012101862959162139819_);}\n\t.st53{display:inline;opacity:0.7;fill:url(#SVGID_00000139256430474945585780000005141426001004935583_);}\n\t.st54{display:inline;opacity:0.7;fill:url(#SVGID_00000078030071797297117620000014013511620120284062_);}\n\t.st55{display:inline;opacity:0.7;fill:url(#SVGID_00000179624230033293924250000011258442133291228556_);}\n\t.st56{display:inline;opacity:0.7;fill:url(#SVGID_00000021085857388242536390000004986637946811191203_);}\n\t.st57{display:inline;opacity:0.7;fill:url(#SVGID_00000028309502648638980430000013076499700839835290_);}\n\t.st58{display:inline;opacity:0.7;fill:url(#SVGID_00000167382355543525491660000002406977859886756509_);}\n\t.st59{display:inline;opacity:0.7;fill:url(#SVGID_00000128476367481254002980000003279946212099647112_);}\n\t.st60{display:inline;opacity:0.7;fill:url(#SVGID_00000162316551856929181230000009350395096618148281_);}\n\t.st61{display:inline;opacity:0.7;fill:url(#SVGID_00000172432977141080922020000009744275471315228808_);}\n\t.st62{display:inline;opacity:0.7;fill:url(#SVGID_00000040569135128398063670000017229088493898126783_);}\n\t.st63{display:inline;fill:#9B881B;}\n\t.st64{display:inline;opacity:0.7;fill:url(#SVGID_00000140721210260638665230000006721559131339858850_);}\n\t.st65{display:inline;opacity:0.7;fill:url(#SVGID_00000039853505215624293500000008586145562756459949_);}\n\t.st66{display:inline;opacity:0.7;fill:url(#SVGID_00000113342065517969490700000005690614545521604770_);}\n\t.st67{fill:#00A0C5;}\n\t.st68{display:inline;opacity:0.8;fill:url(#SVGID_00000021834042582989453500000008986788231932729519_);}\n\t.st69{display:inline;opacity:0.8;fill:url(#SVGID_00000017516315998633872930000011145498746316236721_);}\n\t.st70{display:inline;opacity:0.8;fill:url(#SVGID_00000006687312360383411210000007749520011450909357_);}\n\t.st71{opacity:0.7;fill:url(#SVGID_00000064345390535971445770000001541647364852112005_);}\n\t.st72{opacity:0.7;fill:url(#SVGID_00000174584478757543837610000003781300401872366476_);}\n\t.st73{opacity:0.7;fill:url(#SVGID_00000073714346316321192430000009130181579073573563_);}\n\t.st74{opacity:0.7;fill:url(#SVGID_00000183965918442360655850000013181079526589780926_);}\n\t.st75{opacity:0.7;fill:url(#SVGID_00000139271398238536094050000012948925197923432358_);}\n\t.st76{opacity:0.7;fill:url(#SVGID_00000068652757018359752020000010146835566363496597_);}\n\t.st77{opacity:0.7;fill:url(#SVGID_00000129203924766351324130000008341163961828109463_);}\n\t.st78{opacity:0.7;fill:url(#SVGID_00000153707629618512543440000001398175161045008567_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hilfslinien",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ckeGxW.tif",
    className: "st1"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 360,
    height: 360,
    id: "Layer_0_00000064329209845854057710000013743329231030229434_",
    xlinkHref: "7F20982EF12F6ECB.png",
    transform: "matrix(1 0 0 1 -1870.4475 -228.2344)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_740",
    transform: "translate(-786.086 -17.36)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -423.756 -292.6693)",
    style: {
      fill: "#0198B5",
      fontFamily: "'Roboto-Medium'",
      fontSize: "32.3961px"
    }
  }, "payment"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -297.8576 -292.6693)",
    style: {
      fill: "#0198B5",
      fontFamily: "'Roboto-Light'",
      fontSize: "32.3961px"
    }
  }, "services"), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_25",
    className: "st2",
    d: "M-510.8-338.9c5.2,0,9.9,2.8,12.5,7.2l13.4,23.3c2.6,4.4,2.6,9.9,0,14.4l-13.4,23.3 c-2.6,4.5-7.3,7.2-12.5,7.2h-26.7c-5.2,0-9.9-2.8-12.5-7.2l-13.4-23.3c-2.6-4.4-2.6-9.9,0-14.4l13.4-23.3 c2.6-4.5,7.3-7.2,12.5-7.2H-510.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_26",
    className: "st3",
    d: "M-480.7-338.9c5.2,0,9.9,2.8,12.5,7.2l13.4,23.3c2.6,4.4,2.6,9.9,0,14.4l-13.4,23.3 c-2.6,4.5-7.3,7.2-12.5,7.2h-26.7c-5.2,0-9.9-2.8-12.5-7.2l-13.4-23.3c-2.6-4.4-2.6-9.9,0-14.4l13.4-23.3 c2.6-4.5,7.3-7.2,12.5-7.2H-480.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-1486.6,331.3c-2.1,0-4,1.1-5.1,2.9l-20,34.1c-0.4,0.6-0.6,1.3-0.7,1.9v2.1c0.1,0.7,0.4,1.3,0.7,1.9 l20,34.1c0.9,1.6,2.6,2.7,4.4,2.9h41.6c1.8-0.2,3.4-1.3,4.4-2.9l20-34.1c1.1-1.8,1.1-4.1,0-6l-11.4-19.2l-4,7.4l7.2,12.3 c0.9,1.5,0.9,3.4,0,5l-16.3,27.9c-0.9,1.5-2.5,2.4-4.2,2.4h-32.7c-1.7,0-3.4-0.9-4.2-2.4l-16.3-27.9c-0.9-1.5-0.9-3.4,0-5 l16.3-27.9c0.9-1.5,2.5-2.4,4.2-2.4l31.1,0.1c1.2,0,2.6,0,2.7,0c1.6-0.5,2.7-2,2.7-3.8c0-1.6-1-3-2.3-3.6H-1486.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000186065949317921570000002222109888289627814_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000186065949317921570000002222109888289627814_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000071531332761450323840000012105201516493599884_",
    x: -1512.4,
    y: 331.3,
    width: 92,
    height: 80
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016758418123718412280000009245180594747024811_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071531332761450323840000012105201516493599884_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016758418123718412280000009245180594747024811_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000139281808448243813120000000838860767854196385_",
    x: -1512.4,
    y: 331.3,
    width: 92,
    height: 80
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039832947283707991070000016650243079220959653_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139281808448243813120000000838860767854196385_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039832947283707991070000016650243079220959653_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 384,
    height: 335,
    xlinkHref: "7F20982EF12F6EC9.jpg",
    transform: "matrix(0.24 0 0 0.24 -1512.48 331.02)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000026162611831546928300000003931680596473247633_",
    d: "M-1427.8,317c-2.1,0-4,1.1-5.1,2.9l-20,34.1 c-1.1,1.8-1.1,4.1,0,6l11.4,19.2l4-7.4l-7.2-12.3c-0.9-1.5-0.9-3.4,0-5l16.3-27.9c0.9-1.5,2.5-2.4,4.2-2.4h32.7 c1.7,0,3.4,0.9,4.2,2.4l16.3,27.9c0.9,1.5,0.9,3.4,0,5l-16.3,27.9c-0.9,1.5-2.5,2.4-4.2,2.4l-31.1-0.1c-1.2,0-2.6,0-2.7,0 c-1.6,0.5-2.7,2-2.7,3.8c0,1.6,1,3,2.3,3.6h37.9c2.1,0,4-1.1,5.1-2.9l20-34.1c1.1-1.8,1.1-4.1,0-6l-20-34.1 c-1.1-1.8-3-2.9-5.1-2.9H-1427.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044873961542511844740000017365259708256094607_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026162611831546928300000003931680596473247633_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044873961542511844740000017365259708256094607_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000124143310786291861980000012193877828573325995_",
    x: -1453.9,
    y: 317,
    width: 92.4,
    height: 80.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085944841273111561040000015724579222810820027_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124143310786291861980000012193877828573325995_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085944841273111561040000015724579222810820027_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111886093970518195920000007265807918136302525_",
    x: -1453.9,
    y: 317,
    width: 92.4,
    height: 80.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057148235824864823060000010340455502656768185_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111886093970518195920000007265807918136302525_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057148235824864823060000010340455502656768185_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 386,
    height: 335,
    xlinkHref: "7F20982EF12F6ECF.jpg",
    transform: "matrix(0.24 0 0 0.24 -1454.16 316.86)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080924149327542540760000007666464108980522929_",
    d: "M-1369.1,392.1c0,2.6,2.1,4.8,4.8,4.8 c1.9,0,3.5-1.1,4.3-2.7V390c-0.8-1.6-2.4-2.7-4.3-2.7C-1367,387.3-1369.1,389.4-1369.1,392.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012472196368929837850000015086767139409325496_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080924149327542540760000007666464108980522929_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000012472196368929837850000015086767139409325496_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054947940385265176160000018026101758292956562_",
    x: -1370,
    y: 386.5,
    transform: "matrix(0.9801 -0.1987 0.1987 0.9801 -105.1 -263.3065)",
    width: 10.8,
    height: 11.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023271154629891579040000017658250886809747898_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054947940385265176160000018026101758292956562_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023271154629891579040000017658250886809747898_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065060825194504518720000004032275630392942494_",
    x: -1372.2,
    y: 384.4,
    transform: "matrix(0.9801 -0.1987 0.1987 0.9801 -105.0846 -263.277)",
    width: 15.1,
    height: 15.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113352756103507209160000000183780667432001689_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065060825194504518720000004032275630392942494_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000113352756103507209160000000183780667432001689_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 76,
    height: 76,
    xlinkHref: "7F20982EF12F6EC8.jpg",
    transform: "matrix(0.24 0 0 0.24 -1373.76 382.86)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155867951275168220560000017484972834906847924_",
    d: "M-1609,326.1c-2.3,0-4.4,1.2-5.6,3.2l-21.8,37.2 c-1.2,2-1.2,4.5,0,6.5l12.3,20.6l4.6-7.7l-7.9-13.4c-1-1.7-1-3.7,0-5.4l17.8-30.3c1-1.6,2.7-2.6,4.6-2.6h35.6 c1.9,0,3.7,1,4.6,2.6l17.8,30.3c1,1.7,1,3.7,0,5.4l-17.8,30.3c-1,1.6-2.7,2.6-4.6,2.6h-35.6c-1.9,0-3.7-1-4.6-2.6l-1.3-2 l-4.4,7.8l0.7,1.6c1.2,2,3.3,3.2,5.6,3.2h43.7c2.3,0,4.4-1.2,5.6-3.2l21.8-37.2c1.2-2,1.2-4.5,0-6.5l-21.8-37.2 c-1.2-2-3.3-3.2-5.6-3.2H-1609z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173145641006808156990000006915869938888135615_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155867951275168220560000017484972834906847924_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000173145641006808156990000006915869938888135615_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116940514960400844340000009055474963559557044_",
    x: -1637.5,
    y: 326.1,
    width: 100.6,
    height: 87.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032639650809399883050000001675795857415333300_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116940514960400844340000009055474963559557044_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000032639650809399883050000001675795857415333300_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152231197748665839720000002367550153688139447_",
    x: -1637.5,
    y: 326.1,
    width: 100.6,
    height: 87.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106865098236829678760000009135785284602766465_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152231197748665839720000002367550153688139447_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106865098236829678760000009135785284602766465_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 420,
    height: 364,
    xlinkHref: "7F20982EF12F6ECB.jpg",
    transform: "matrix(0.24 0 0 0.24 -1637.52 325.98)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000169543245877439505080000009501403025585801899_",
    d: "M-1669.5,326.1c-2.3,0-4.4,1.2-5.6,3.2l-21.8,37.2 c-1.2,2-1.2,4.5,0,6.5l21.8,37.2c1.2,2,3.3,3.2,5.6,3.2h43.7c2.3,0,4.4-1.2,5.6-3.2l21.8-37.2c1.2-2,1.2-4.5,0-6.5l-12.4-20.9 l-4.4,8l7.8,13.4c1,1.7,1,3.7,0,5.4l-17.8,30.3c-1,1.6-2.7,2.6-4.6,2.6h-35.6c-1.9,0-3.7-1-4.6-2.6l-17.8-30.3 c-1-1.7-1-3.7,0-5.4l17.8-30.3c1-1.6,2.7-2.6,4.6-2.6h35.6c1.9,0,3.7,1,4.6,2.6l1,1.4l4.8-7.5l-0.8-1.3c-1.2-2-3.3-3.2-5.6-3.2 H-1669.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025428057451072335090000001114195575713092753_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169543245877439505080000009501403025585801899_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000025428057451072335090000001114195575713092753_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163786543480785336020000009571809490121857691_",
    x: -1697.9,
    y: 326.1,
    width: 100.6,
    height: 87.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151511717634811262180000006617822205131265450_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163786543480785336020000009571809490121857691_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000151511717634811262180000006617822205131265450_)"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119823334173860557190000012247747000417319091_",
    x: -1697.9,
    y: 326.1,
    width: 100.6,
    height: 87.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029016949162076946100000015336844865149822112_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119823334173860557190000012247747000417319091_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000029016949162076946100000015336844865149822112_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 420,
    height: 364,
    xlinkHref: "7F20982EF12F6EC7.jpg",
    transform: "matrix(0.24 0 0 0.24 -1698 325.98)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000070833001951985068390000007906952242832589480_",
    d: "M-1548.5,413.8c0-1.9,1.5-3.5,3.4-3.5 c2,0,3.4,1.6,3.4,3.5c0,1.9-1.5,3.5-3.4,3.5C-1547,417.3-1548.5,415.7-1548.5,413.8 M-1550.3,414c0,2.5,1.9,4.5,4.3,4.9h1.7 c1.1-0.2,2-0.8,2.5-1.7h0v1.5h1.8v-9.8h-1.8v1.4h0c-0.8-1.1-2-1.7-3.4-1.7C-1548.1,408.6-1550.3,410.8-1550.3,414"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178889647025053656040000010873268852213934999_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070833001951985068390000007906952242832589480_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178889647025053656040000010873268852213934999_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000169521439406350346540000009214722235391978659_",
    x: -1550.3,
    y: 408.6,
    width: 10.4,
    height: 10.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091009026875760270160000001734981566242502055_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169521439406350346540000009214722235391978659_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091009026875760270160000001734981566242502055_)"
    }
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183244200712137896990000017760258006468432776_",
    x: -1550.3,
    y: 408.6,
    width: 10.4,
    height: 10.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089559506061208717110000001283715147554298262_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183244200712137896990000017760258006468432776_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000089559506061208717110000001283715147554298262_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 44,
    height: 44,
    xlinkHref: "7F20982EF12F6ED7.jpg",
    transform: "matrix(0.24 0 0 0.24 -1550.4 408.54)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000094581251330855068450000009113594053480468654_",
    d: "M-1538.1,413.9c0,2.5,1.8,4.6,4.2,5h1.7 c1.8-0.3,3.3-1.5,4-3.4h-2.1c-0.5,1.1-1.5,1.8-2.8,1.8c-1.9,0-3.2-1.5-3.2-3.5c0-2,1.3-3.5,3.2-3.5c1.3,0,2.2,0.7,2.8,1.8h2 c-0.6-2.1-2.6-3.5-4.9-3.5C-1535.9,408.6-1538.1,410.9-1538.1,413.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090283331001619376510000013259171139224387519_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094581251330855068450000009113594053480468654_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000090283331001619376510000013259171139224387519_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000040549293810387433920000014543209267181687203_",
    x: -1538.1,
    y: 408.6,
    width: 9.9,
    height: 10.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003082447579816470530000001643152068437394323_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040549293810387433920000014543209267181687203_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003082447579816470530000001643152068437394323_)"
    }
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000095334360696744759790000011766588744893577118_",
    x: -1538.1,
    y: 408.6,
    width: 9.9,
    height: 10.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142159406134297250400000000733464840507902904_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095334360696744759790000011766588744893577118_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000142159406134297250400000000733464840507902904_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 42,
    height: 44,
    xlinkHref: "7F20982EF12F6ED9.jpg",
    transform: "matrix(0.24 0 0 0.24 -1538.16 408.54)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000164503965335673164850000003510005397642722748_",
    points: "-1525.5,405.6 -1525.5,408.9 -1526.8,408.9  -1526.8,410.6 -1525.5,410.6 -1525.5,418.7 -1523.7,418.7 -1523.7,410.6 -1522,410.6 -1522,408.9 -1523.7,408.9 -1523.7,405.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165205406109266239360000000392976435430075264_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164503965335673164850000003510005397642722748_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165205406109266239360000000392976435430075264_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000109024268977086461340000017288982426100876943_",
    x: -1526.8,
    y: 405.6,
    width: 4.8,
    height: 13.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001637337953508825360000004001412357901440180_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109024268977086461340000017288982426100876943_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000001637337953508825360000004001412357901440180_)"
    }
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083795256823122774100000000936408838844554117_",
    x: -1526.8,
    y: 405.6,
    width: 4.8,
    height: 13.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082358325393401892220000015706693847059572622_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083795256823122774100000000936408838844554117_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000082358325393401892220000015706693847059572622_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 21,
    height: 56,
    xlinkHref: "7F20982EF12F6EDB.jpg",
    transform: "matrix(0.24 0 0 0.24 -1526.88 405.42)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000034058762088524596380000006401490657049789359_",
    x: -1521.5,
    y: 416.6,
    width: 1.6,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133512028232346361810000010546599817011074711_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034058762088524596380000006401490657049789359_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000133512028232346361810000010546599817011074711_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000137828216763284999550000004782757200420411284_",
    x: -1521.5,
    y: 416.6,
    width: 1.6,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127031265906052964150000001172245679178964660_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137828216763284999550000004782757200420411284_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127031265906052964150000001172245679178964660_)"
    }
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000029728891106086923220000006485604025614170249_",
    x: -1521.5,
    y: 416.6,
    width: 1.6,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047753863970039765250000000744395044517381805_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029728891106086923220000006485604025614170249_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047753863970039765250000000744395044517381805_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 8,
    height: 10,
    xlinkHref: "5FB5FEC8DBDB0368.jpg",
    transform: "matrix(0.24 0 0 0.24 -1521.6 416.46)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000142868311169884012880000012526763159737907610_",
    d: "M-971.7,537.3l-16.3-27.9c-0.9-1.5-0.9-3.4,0-5 l16.3-27.9c0.9-1.5,2.5-2.4,4.2-2.4h32.7c1.7,0,3.4,0.9,4.2,2.4l16.3,27.9c0.9,1.5,0.9,3.4,0,5l-16.3,27.9 c-0.9,1.5-2.5,2.4-4.2,2.4h-32.7C-969.2,539.7-970.8,538.8-971.7,537.3 M-971.2,466.9c-2.1,0-4,1.1-5.1,2.9l-20,34.1 c-1.1,1.8-1.1,4.1,0,6l20,34.1c1.1,1.8,3,2.9,5.1,2.9h40.1c2.1,0,4-1.1,5.1-2.9l20-34.1c0.1-0.2,0.2-0.5,0.3-0.7v-4.6 c-0.1-0.2-0.2-0.5-0.3-0.7l-20-34.1c-1.1-1.8-3-2.9-5.1-2.9H-971.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032628668726637217300000004239546100169476480_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142868311169884012880000012526763159737907610_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000032628668726637217300000004239546100169476480_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000120558884930276706630000012339853461290697344_",
    x: -997.3,
    y: 466.9,
    width: 91.7,
    height: 80.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177462832938607724380000001409976438167312546_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120558884930276706630000012339853461290697344_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000177462832938607724380000001409976438167312546_)"
    }
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000129201836198906794240000014353349263921709502_",
    x: -997.3,
    y: 466.9,
    width: 91.7,
    height: 80.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041284807705376925170000017239510045440635550_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129201836198906794240000014353349263921709502_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041284807705376925170000017239510045440635550_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 383,
    height: 334,
    xlinkHref: "5FB5FEC8DBDB036F.jpg",
    transform: "matrix(0.24 0 0 0.24 -997.44 466.86)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000027600143121001174580000016190011815092863121_",
    d: "M-1032.6,461.8c-2.3,0-4.4,1.2-5.5,3.2l-21.7,37.1 c-1.2,2-1,7.8-1,10.6l0.9,41.4c0.4,2.2,1.5,4.6,3.7,5.2h2.5l14.3-5.7l50.5-4.8c2.3,0,4.4-1.2,5.5-3.2l2.8-3.8l-4.4-7.1l-2.8,5.3 c-1,1.7-2.7,2.7-4.6,2.7l-47.4,4.3l-7.6,3.3c-3.3,1-5.2-1.4-5.7-3.8l0.5-34.1c0-2.4-0.2-7.2,0.8-8.9l18.2-31.1 c1-1.7,2.7-2.7,4.6-2.7h36.5c1.9,0,3.7,1,4.6,2.7l18.2,31.1c1,1.7,1,3.8,0,5.4l-7.7,13.5l3.9,6.6l11.8-20.5c1.2-2,1.2-4.5,0-6.5 l-21.7-37.1c-1.2-2-3.3-3.2-5.5-3.2H-1032.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000143600409114775071180000003028200022104260003_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027600143121001174580000016190011815092863121_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000143600409114775071180000003028200022104260003_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023271843523916272140000012001722023317958542_",
    x: -1061,
    y: 461.8,
    width: 100.5,
    height: 97.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085972542202209471200000004863366145364378282_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023271843523916272140000012001722023317958542_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085972542202209471200000004863366145364378282_)"
    }
  }, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000026854510252989166060000012765633391652684712_",
    x: -1061,
    y: 461.8,
    width: 100.5,
    height: 97.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064330660547470055330000003563897915102325653_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026854510252989166060000012765633391652684712_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000064330660547470055330000003563897915102325653_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 419,
    height: 408,
    xlinkHref: "5FB5FEC8DBDB0369.jpg",
    transform: "matrix(0.24 0 0 0.24 -1061.04 461.58)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000112616132455437959980000011685123696755487630_",
    d: "M-856.9,455.3c-2.1,0-4,1.1-5.1,2.9l-20,34.1 c-0.2,0.4-0.4,0.8-0.5,1.2v3.6c0.1,0.4,0.3,0.8,0.5,1.2l0.4,34.1c0.7,1.2,3.1,2.1,5.3,2.5h61.5c1.3-0.5,2.3-1.4,3-2.5l20-34.1 c1.1-1.8,1.1-4.1,0-6l-11.3-18.9l-4.2,7.1l7.3,12.3c0.9,1.5,0.9,3.4,0,5l-16.3,27.9c-0.9,1.5-2.5,2.4-4.2,2.4h-49.1 c-1.7,0-3.4-0.9-4.2-2.4l0.1-27.9c-0.9-1.5-0.9-3.4,0-5l16.3-27.9c0.9-1.5,2.5-2.4,4.2-2.4h32.7c1.7,0,3.4,0.9,4.2,2.4l1.2,1.9 l4-7.2l-0.6-1.5c-1.1-1.8-3-2.9-5.1-2.9H-856.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156588215406334638180000008158526185068045728_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112616132455437959980000011685123696755487630_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000156588215406334638180000008158526185068045728_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000014620849953671076230000013552685786682988193_",
    x: -882.5,
    y: 455.3,
    width: 91.8,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099646309257515704260000003845397668777447850_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014620849953671076230000013552685786682988193_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000099646309257515704260000003845397668777447850_)"
    }
  }, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000035490047473363695940000018318168578776547456_",
    x: -882.5,
    y: 455.3,
    width: 91.8,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069364637025210305070000010698072608507564674_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035490047473363695940000018318168578776547456_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000069364637025210305070000010698072608507564674_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 384,
    height: 333,
    xlinkHref: "5FB5FEC8DBDB036B.jpg",
    transform: "matrix(0.24 0 0 0.24 -882.72 455.1)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000065791513938835617400000000125492193618890373_",
    d: "M-801.4,455.3c-2.1,0-4,1.1-5.1,2.9l-20,34.1 c-1.1,1.8-1.1,4.1,0,6l11.4,19.2l4-7.4l-7.2-12.3c-0.9-1.5-0.9-3.4,0-5l16.3-27.9c0.9-1.5,2.5-2.4,4.2-2.4h32.7 c1.7,0,3.4,0.9,4.2,2.4l16.3,27.9c0.9,1.5,0.9,3.4,0,5l-0.4,27.9c-0.9,1.5-0.9,2.4-2.6,2.4h-50.2c-1.7,0-3.4-0.9-4.2-2.4 l-0.9-1.3l-4.4,6.9l0.8,1.2c0.7,1.2,1.8,2.1,3,2.5h62.1c1.7-0.5,3.5-1.4,4.2-2.5l0.9-34.1c0.4-0.7,0.7-1.6,0.8-2.4v-1.1 c-0.1-0.8-0.3-1.7-0.8-2.4l-20-34.1c-1.1-1.8-3-2.9-5.1-2.9H-801.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050663818468948934340000013410799390187493818_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065791513938835617400000000125492193618890373_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000050663818468948934340000013410799390187493818_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000178206977086532235750000015100175617039010707_",
    x: -827.5,
    y: 455.3,
    width: 92.1,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005247087559282344770000012874399910516499365_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178206977086532235750000015100175617039010707_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005247087559282344770000012874399910516499365_)"
    }
  }, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127029755191061269280000016794985855230376069_",
    x: -827.5,
    y: 455.3,
    width: 92.1,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137855079988017476730000008509213583126195594_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127029755191061269280000016794985855230376069_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137855079988017476730000008509213583126195594_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 385,
    height: 333,
    xlinkHref: "5FB5FEC8DBDB0376.jpg",
    transform: "matrix(0.24 0 0 0.24 -827.76 455.1)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000018214415852735183610000002077530295447345033_",
    d: "M-1864.9,332.4l-19.6,33.5v9.5l23.2,39.7 c0.8,1.3,1.9,2.3,3.3,2.9h53.7c1.3-0.6,2.5-1.6,3.3-2.9l19.8-33.8l-0.1-0.1c0.4-0.7,0.7-1.5,0.7-2.3c0-2.5-2-4.4-4.4-4.4 c-1.2,0-2.3,0.5-3.1,1.3l-0.9,1.5l-17.4,29.8c-1.1,1.8-3,2.9-5.1,2.9h-39.2c-2.1,0-4-1.1-5.1-2.9l-19.5-33.4 c-1.1-1.8-1.1-4.1,0-5.9l17.3-29.6l0-0.1c0.6-0.7,0.9-1.7,0.9-2.7c0-2.5-2-4.4-4.4-4.4C-1862.8,330.8-1864,331.4-1864.9,332.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168797269626249804570000009869525431145197485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018214415852735183610000002077530295447345033_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000168797269626249804570000009869525431145197485_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000090255589942416956040000002936617664170861747_",
    x: -1884.4,
    y: 330.8,
    width: 103.9,
    height: 87.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126283708929898903520000005095576469594072489_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090255589942416956040000002936617664170861747_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000126283708929898903520000005095576469594072489_)"
    }
  }, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000090258145481493070340000013717213617083080374_",
    x: -1884.4,
    y: 330.8,
    width: 103.9,
    height: 87.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081615443119063006570000012436278662115501703_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090258145481493070340000013717213617083080374_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000081615443119063006570000012436278662115501703_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 434,
    height: 364,
    xlinkHref: "5FB5FEC8DBDB0377.jpg",
    transform: "matrix(0.24 0 0 0.24 -1884.48 330.78)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103253845931731488130000006652192057570087047_",
    d: "M-1788.6,324.3c-2.5,0-4.8,1.3-6.1,3.5l-19.8,33.8 l0.1,0.1c-0.4,0.7-0.7,1.5-0.7,2.3c0,2.5,2,4.4,4.4,4.4c1.2,0,2.3-0.5,3.1-1.3l0.9-1.5l17.4-29.8c1.1-1.8,3-2.9,5.1-2.9h39.2 c2.1,0,4,1.1,5.1,2.9l19.5,33.4c1.1,1.8,1.1,4.1,0,5.9l-17.3,29.6l0,0.1c-0.6,0.7-0.9,1.7-0.9,2.7c0,2.5,2,4.4,4.4,4.4 c1.4,0,2.5-0.6,3.4-1.6l20.3-34.6c1.3-2.2,1.3-4.9,0-7.1l-23.9-40.9c-1.3-2.2-3.6-3.5-6.1-3.5H-1788.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132797139057315800750000004694313233020304031_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103253845931731488130000006652192057570087047_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132797139057315800750000004694313233020304031_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000041288554351308871950000014002279476846693278_",
    x: -1815.2,
    y: 324.3,
    width: 105.9,
    height: 87.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134226679645654659700000001072359589764748966_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041288554351308871950000014002279476846693278_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134226679645654659700000001072359589764748966_)"
    }
  }, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114073480159485963050000012974061233531038376_",
    x: -1815.2,
    y: 324.3,
    width: 105.9,
    height: 87.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162330949603800200840000013966194351476906900_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114073480159485963050000012974061233531038376_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000162330949603800200840000013966194351476906900_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 442,
    height: 366,
    xlinkHref: "5FB5FEC8DBDB0378.jpg",
    transform: "matrix(0.24 0 0 0.24 -1815.36 324.3)"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M-1809.2,702.4l-5.1-8.8c-0.5-0.8-1.7-0.8-2.2,0l-3,5c-0.2,0.4-0.2,0.9,0,1.3l1.8,3c1.1,1.8,1.1,4,0,5.9 l-16.5,28.1c-1,1.8-2.9,2.9-5,2.9h-33c-2.1,0-4-1.1-5-2.9l-16.5-28.1c-1.1-1.8-1.1-4,0-5.9l16.5-28.1c1-1.8,2.9-2.9,5-2.9h33 c2.1,0,4,1.1,5,2.9l1.9,3.2c0.2,0.3,0.6,0.3,0.7,0l3.7-6.2c0.2-0.4,0.2-0.9,0-1.3l-1.6-2.8c-1.2-2.1-3.5-3.4-5.9-3.4h-40.7 c-2.4,0-4.7,1.3-5.9,3.4l-20.3,34.6c-1.2,2.1-1.2,4.8,0,6.9l20.3,34.6c1.2,2.1,3.5,3.4,5.9,3.4h40.7c2.4,0,4.7-1.3,5.9-3.4 l20.3-34.6C-1808,707.2-1808,704.5-1809.2,702.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M-1838.8,709.3l5.1,8.8c0.5,0.8,1.7,0.8,2.2,0l3-5c0.2-0.4,0.2-0.9,0-1.3l-1.8-3c-1.1-1.8-1.1-4,0-5.9 l16.5-28.1c1-1.8,2.9-2.9,5-2.9h33c2.1,0,4,1.1,5,2.9l16.5,28.1c1.1,1.8,1.1,4,0,5.9l-16.5,28.1c-1,1.8-2.9,2.9-5,2.9h-33 c-2.1,0-4-1.1-5-2.9l-1.9-3.2c-0.2-0.3-0.6-0.3-0.7,0l-3.7,6.2c-0.2,0.4-0.2,0.9,0,1.3l1.6,2.8c1.2,2.1,3.5,3.4,5.9,3.4h40.7 c2.4,0,4.7-1.3,5.9-3.4l20.3-34.6c1.2-2.1,1.2-4.8,0-6.9l-20.3-34.6c-1.2-2.1-3.5-3.4-5.9-3.4h-40.7c-2.4,0-4.7,1.3-5.9,3.4 l-20.3,34.6C-1840,704.5-1840,707.2-1838.8,709.3z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M-1654.7,665.1h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3c-1.4,2.4-1.4,5.4,0,7.8l19.2,33.3 c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3c1.4-2.4,1.4-5.4,0-7.8l-19.2-33.3 C-1649.3,666.5-1651.9,665.1-1654.7,665.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082328222119569533180000009249294178991611544_",
    gradientUnits: "userSpaceOnUse",
    x1: -1476.9296,
    y1: 551.3154,
    x2: -1443.7588,
    y2: 579.149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000082328222119569533180000009249294178991611544_)"
    },
    d: " M-1436.9,563.7l-7.6-13.1c-0.5-0.9-1.6-1.5-2.7-1.5h-11.4h-3.7h-11.4c-1.1,0-2.1,0.6-2.7,1.5l-7.6,13.1c-0.5,0.9-0.5,2.1,0,3.1 l7.6,13.1c0.5,0.9,1.6,1.5,2.7,1.5h11.4h3.7h11.4c1.1,0,2.1-0.6,2.7-1.5l7.6-13.1C-1436.3,565.8-1436.3,564.6-1436.9,563.7z  M-1474.5,576.9l-5.8-10.1c-0.5-0.9-0.5-2.1,0-3.1l5.8-10.1c0.5-0.9,1.6-1.5,2.7-1.5h6.2l-6.7,11.6c-0.5,0.9-0.5,2.1,0,3.1 l6.7,11.6h-6.2C-1473,578.4-1474,577.8-1474.5,576.9z M-1460.5,578.4c-1.1,0-2.1-0.6-2.7-1.5l-5.8-10.1c-0.5-0.9-0.5-2.1,0-3.1 l5.8-10.1c0.5-0.9,1.6-1.5,2.7-1.5h0.3c1.1,0,2.1,0.6,2.7,1.5l5.8,10.1c0.5,0.9,0.5,2.1,0,3.1l-5.8,10.1c-0.5,0.9-1.6,1.5-2.7,1.5 H-1460.5z M-1440.3,566.8l-5.8,10.1c-0.5,0.9-1.6,1.5-2.7,1.5h-6.2l6.7-11.6c0.5-0.9,0.5-2.1,0-3.1l-6.7-11.6h6.2 c1.1,0,2.1,0.6,2.7,1.5l5.8,10.1C-1439.8,564.6-1439.8,565.8-1440.3,566.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034070696991917900850000004849432440239974585_",
    gradientUnits: "userSpaceOnUse",
    x1: -1899.2407,
    y1: 580.1986,
    x2: -1806.6543,
    y2: 580.1986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#926EC1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000034070696991917900850000004849432440239974585_)"
    },
    d: " M-1807.7,576.3l-19.2-33.3c-1.4-2.4-4-3.9-6.8-3.9h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3c-1.4,2.4-1.4,5.4,0,7.8l19.2,33.3 c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3C-1806.3,581.7-1806.3,578.7-1807.7,576.3z M-1816.5,584.1l-14.9,25.7 c-1.4,2.4-4,3.9-6.8,3.9h-29.7c-2.8,0-5.4-1.5-6.8-3.9l-14.9-25.7c-1.4-2.4-1.4-5.4,0-7.8l14.9-25.7c1.4-2.4,4-3.9,6.8-3.9h29.7 c2.8,0,5.4,1.5,6.8,3.9l14.9,25.7C-1815.1,578.7-1815.1,581.7-1816.5,584.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119100849104913953130000001485657660983965312_",
    gradientUnits: "userSpaceOnUse",
    x1: -1984.0178,
    y1: 580.1986,
    x2: -1983.5178,
    y2: 580.1986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03C2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#00DCD2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000119100849104913953130000001485657660983965312_)"
    },
    d: " M-1778.7,576.3l-19.2-33.3c-1.4-2.4-4-3.9-6.8-3.9h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3c-1.4,2.4-1.4,5.4,0,7.8l19.2,33.3 c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3C-1777.3,581.7-1777.3,578.7-1778.7,576.3z M-1787.5,584.1l-14.9,25.7 c-1.4,2.4-4,3.9-6.8,3.9h-29.7c-2.8,0-5.4-1.5-6.8-3.9l-14.9-25.7c-1.4-2.4-1.4-5.4,0-7.8l14.9-25.7c1.4-2.4,4-3.9,6.8-3.9h29.7 c2.8,0,5.4,1.5,6.8,3.9l14.9,25.7C-1786.1,578.7-1786.1,581.7-1787.5,584.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105386825540442471490000008227011843110077328_",
    gradientUnits: "userSpaceOnUse",
    x1: -1697.2407,
    y1: 487.1986,
    x2: -1604.6543,
    y2: 487.1986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000105386825540442471490000008227011843110077328_)"
    },
    d: " M-1605.7,483.3l-19.2-33.3c-1.4-2.4-4-3.9-6.8-3.9h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3c-1.4,2.4-1.4,5.4,0,7.8l19.2,33.3 c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3C-1604.3,488.7-1604.3,485.7-1605.7,483.3z M-1614.5,491.1l-14.9,25.7 c-1.4,2.4-4,3.9-6.8,3.9h-29.7c-2.8,0-5.4-1.5-6.8-3.9l-14.9-25.7c-1.4-2.4-1.4-5.4,0-7.8l14.9-25.7c1.4-2.4,4-3.9,6.8-3.9h29.7 c2.8,0,5.4,1.5,6.8,3.9l14.9,25.7C-1613.1,485.7-1613.1,488.7-1614.5,491.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040544521743976422270000014120868168847907773_",
    gradientUnits: "userSpaceOnUse",
    x1: 2761.4475,
    y1: -591.0967,
    x2: 2815.2407,
    y2: -591.0967,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000040544521743976422270000014120868168847907773_)"
    },
    d: " M-1559.6,609.2l11.2,19.4c0.8,1.4,2.3,2.3,3.9,2.3h22.4c1.6,0,3.1-0.9,3.9-2.3l11.2-19.4c0.8-1.4,0.8-3.1,0-4.5l-11.2-19.4 c-0.8-1.4-2.3-2.3-3.9-2.3h-22.4c-1.6,0-3.1,0.9-3.9,2.3l-11.2,19.4C-1560.4,606.1-1560.4,607.8-1559.6,609.2z M-1554.5,604.7 l8.6-15c0.8-1.4,2.3-2.3,3.9-2.3h17.3c1.6,0,3.1,0.9,3.9,2.3l8.6,15c0.8,1.4,0.8,3.1,0,4.5l-8.6,15c-0.8,1.4-2.3,2.3-3.9,2.3h-17.3 c-1.6,0-3.1-0.9-3.9-2.3l-8.6-15C-1555.3,607.8-1555.3,606.1-1554.5,604.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043417104348205278840000011974504250706661769_",
    gradientUnits: "userSpaceOnUse",
    x1: 2670.4475,
    y1: -471.0967,
    x2: 2724.2407,
    y2: -471.0967,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000043417104348205278840000011974504250706661769_)"
    },
    d: " M-1468.6,489.2l11.2,19.4c0.8,1.4,2.3,2.3,3.9,2.3h22.4c1.6,0,3.1-0.9,3.9-2.3l11.2-19.4c0.8-1.4,0.8-3.1,0-4.5l-11.2-19.4 c-0.8-1.4-2.3-2.3-3.9-2.3h-22.4c-1.6,0-3.1,0.9-3.9,2.3l-11.2,19.4C-1469.4,486.1-1469.4,487.8-1468.6,489.2z M-1463.5,484.7 l8.6-15c0.8-1.4,2.3-2.3,3.9-2.3h17.3c1.6,0,3.1,0.9,3.9,2.3l8.6,15c0.8,1.4,0.8,3.1,0,4.5l-8.6,15c-0.8,1.4-2.3,2.3-3.9,2.3h-17.3 c-1.6,0-3.1-0.9-3.9-2.3l-8.6-15C-1464.3,487.8-1464.3,486.1-1463.5,484.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045614386180771939280000010757835964979987641_",
    gradientUnits: "userSpaceOnUse",
    x1: 2670.4475,
    y1: -456.0967,
    x2: 2724.2407,
    y2: -456.0967,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000045614386180771939280000010757835964979987641_)"
    },
    d: " M-1468.6,474.2l11.2,19.4c0.8,1.4,2.3,2.3,3.9,2.3h22.4c1.6,0,3.1-0.9,3.9-2.3l11.2-19.4c0.8-1.4,0.8-3.1,0-4.5l-11.2-19.4 c-0.8-1.4-2.3-2.3-3.9-2.3h-22.4c-1.6,0-3.1,0.9-3.9,2.3l-11.2,19.4C-1469.4,471.1-1469.4,472.8-1468.6,474.2z M-1463.5,469.7 l8.6-15c0.8-1.4,2.3-2.3,3.9-2.3h17.3c1.6,0,3.1,0.9,3.9,2.3l8.6,15c0.8,1.4,0.8,3.1,0,4.5l-8.6,15c-0.8,1.4-2.3,2.3-3.9,2.3h-17.3 c-1.6,0-3.1-0.9-3.9-2.3l-8.6-15C-1464.3,472.8-1464.3,471.1-1463.5,469.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080913295129678699010000008609644285385856703_",
    gradientUnits: "userSpaceOnUse",
    x1: 532.3279,
    y1: 1189.3568,
    x2: 509.6175,
    y2: 1150.0212,
    gradientTransform: "matrix(0 1 -1 0 817.0858 -376.9142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BDB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2197"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.8,
      fill: "url(#SVGID_00000080913295129678699010000008609644285385856703_)"
    },
    d: "M-352.6,159.9 l3.6,2.1c1,0.6,2.1,0.6,3.1,0l13.2-7.6c1-0.6,1.5-1.6,1.5-2.7v-15.2c0-1.1-0.6-2.1-1.5-2.7l-13.2-7.6c-1-0.6-2.1-0.6-3.1,0 l-3.6,2.1l-3.6-2.1c-1-0.6-2.1-0.6-3.1,0l-13.2,7.6c-1,0.6-1.5,1.6-1.5,2.7v15.2c0,1.1,0.6,2.1,1.5,2.7l13.2,7.6 c1,0.6,2.1,0.6,3.1,0L-352.6,159.9z M-349,129.6c1-0.6,2.1-0.6,3.1,0l10.2,5.9c1,0.6,1.5,1.6,1.5,2.7v11.7c0,1.1-0.6,2.1-1.5,2.7 l-10.2,5.9c-1,0.6-2.1,0.6-3.1,0l-0.6-0.3l6.6-3.8c1-0.6,1.5-1.6,1.5-2.7v-15.2c0-1.1-0.6-2.1-1.5-2.7l-6.6-3.8L-349,129.6z  M-352.6,156.4l-6.6-3.8c-1-0.6-1.5-1.6-1.5-2.7v-11.7c0-1.1,0.6-2.1,1.5-2.7l6.6-3.8l6.6,3.8c1,0.6,1.5,1.6,1.5,2.7v11.7 c0,1.1-0.6,2.1-1.5,2.7L-352.6,156.4z M-359.2,158.5l-10.2-5.9c-1-0.6-1.5-1.6-1.5-2.7v-11.7c0-1.1,0.6-2.1,1.5-2.7l10.2-5.9 c1-0.6,2.1-0.6,3.1,0l0.6,0.3l-6.6,3.8c-1,0.6-1.5,1.6-1.5,2.7v15.2c0,1.1,0.6,2.1,1.5,2.7l6.6,3.8l-0.6,0.3 C-357.1,159-358.3,159-359.2,158.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066507141839010563840000006864684901060816056_",
    gradientUnits: "userSpaceOnUse",
    x1: 2780.4475,
    y1: -578.0967,
    x2: 2834.2407,
    y2: -578.0967,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000066507141839010563840000006864684901060816056_)"
    },
    d: " M-1578.6,596.2l11.2,19.4c0.8,1.4,2.3,2.3,3.9,2.3h22.4c1.6,0,3.1-0.9,3.9-2.3l11.2-19.4c0.8-1.4,0.8-3.1,0-4.5l-11.2-19.4 c-0.8-1.4-2.3-2.3-3.9-2.3h-22.4c-1.6,0-3.1,0.9-3.9,2.3l-11.2,19.4C-1579.4,593.1-1579.4,594.8-1578.6,596.2z M-1573.5,591.7 l8.6-15c0.8-1.4,2.3-2.3,3.9-2.3h17.3c1.6,0,3.1,0.9,3.9,2.3l8.6,15c0.8,1.4,0.8,3.1,0,4.5l-8.6,15c-0.8,1.4-2.3,2.3-3.9,2.3h-17.3 c-1.6,0-3.1-0.9-3.9-2.3l-8.6-15C-1574.3,594.8-1574.3,593.1-1573.5,591.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119810853489858018010000010326671492876530617_",
    gradientUnits: "userSpaceOnUse",
    x1: 2746.4475,
    y1: -578.0967,
    x2: 2800.2407,
    y2: -578.0967,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000119810853489858018010000010326671492876530617_)"
    },
    d: " M-1544.6,596.2l11.2,19.4c0.8,1.4,2.3,2.3,3.9,2.3h22.4c1.6,0,3.1-0.9,3.9-2.3l11.2-19.4c0.8-1.4,0.8-3.1,0-4.5l-11.2-19.4 c-0.8-1.4-2.3-2.3-3.9-2.3h-22.4c-1.6,0-3.1,0.9-3.9,2.3l-11.2,19.4C-1545.4,593.1-1545.4,594.8-1544.6,596.2z M-1539.5,591.7 l8.6-15c0.8-1.4,2.3-2.3,3.9-2.3h17.3c1.6,0,3.1,0.9,3.9,2.3l8.6,15c0.8,1.4,0.8,3.1,0,4.5l-8.6,15c-0.8,1.4-2.3,2.3-3.9,2.3h-17.3 c-1.6,0-3.1-0.9-3.9-2.3l-8.6-15C-1540.3,594.8-1540.3,593.1-1539.5,591.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091723433993785294390000001766910081712018816_",
    gradientUnits: "userSpaceOnUse",
    x1: 2746.4475,
    y1: -602.0967,
    x2: 2800.2407,
    y2: -602.0967,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000091723433993785294390000001766910081712018816_)"
    },
    d: " M-1544.6,620.2l11.2,19.4c0.8,1.4,2.3,2.3,3.9,2.3h22.4c1.6,0,3.1-0.9,3.9-2.3l11.2-19.4c0.8-1.4,0.8-3.1,0-4.5l-11.2-19.4 c-0.8-1.4-2.3-2.3-3.9-2.3h-22.4c-1.6,0-3.1,0.9-3.9,2.3l-11.2,19.4C-1545.4,617.1-1545.4,618.8-1544.6,620.2z M-1539.5,615.7 l8.6-15c0.8-1.4,2.3-2.3,3.9-2.3h17.3c1.6,0,3.1,0.9,3.9,2.3l8.6,15c0.8,1.4,0.8,3.1,0,4.5l-8.6,15c-0.8,1.4-2.3,2.3-3.9,2.3h-17.3 c-1.6,0-3.1-0.9-3.9-2.3l-8.6-15C-1540.3,618.8-1540.3,617.1-1539.5,615.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121257831061176389070000001298838196040061084_",
    gradientUnits: "userSpaceOnUse",
    x1: 2644.4475,
    y1: -666.0967,
    x2: 2698.2407,
    y2: -666.0967,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000121257831061176389070000001298838196040061084_)"
    },
    d: " M-1442.6,684.2l11.2,19.4c0.8,1.4,2.3,2.3,3.9,2.3h22.4c1.6,0,3.1-0.9,3.9-2.3l11.2-19.4c0.8-1.4,0.8-3.1,0-4.5l-11.2-19.4 c-0.8-1.4-2.3-2.3-3.9-2.3h-22.4c-1.6,0-3.1,0.9-3.9,2.3l-11.2,19.4C-1443.4,681.1-1443.4,682.8-1442.6,684.2z M-1437.5,679.7 l8.6-15c0.8-1.4,2.3-2.3,3.9-2.3h17.3c1.6,0,3.1,0.9,3.9,2.3l8.6,15c0.8,1.4,0.8,3.1,0,4.5l-8.6,15c-0.8,1.4-2.3,2.3-3.9,2.3h-17.3 c-1.6,0-3.1-0.9-3.9-2.3l-8.6-15C-1438.3,682.8-1438.3,681.1-1437.5,679.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031197450135389710670000003053057011383797635_",
    gradientUnits: "userSpaceOnUse",
    x1: 2644.4475,
    y1: -646.0928,
    x2: 2671.2407,
    y2: -646.0928,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000031197450135389710670000003053057011383797635_)"
    },
    d: " M-1415.9,663.1l5.6,9.6c0.4,0.7,1.1,1.1,2,1.1h11.1c0.8,0,1.6-0.4,2-1.1l5.6-9.6c0.4-0.7,0.4-1.6,0-2.3l-5.6-9.6 c-0.4-0.7-1.1-1.1-2-1.1h-11.1c-0.8,0-1.6,0.4-2,1.1l-5.6,9.6C-1416.3,661.5-1416.3,662.4-1415.9,663.1z M-1413.4,660.8l4.3-7.4 c0.4-0.7,1.1-1.1,2-1.1h8.6c0.8,0,1.6,0.4,2,1.1l4.3,7.4c0.4,0.7,0.4,1.6,0,2.3l-4.3,7.4c-0.4,0.7-1.1,1.1-2,1.1h-8.6 c-0.8,0-1.6-0.4-2-1.1l-4.3-7.4C-1413.8,662.4-1413.8,661.5-1413.4,660.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080192264149252127100000016994101109146412460_",
    gradientUnits: "userSpaceOnUse",
    x1: 2623.4475,
    y1: -687.0928,
    x2: 2650.2407,
    y2: -687.0928,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000080192264149252127100000016994101109146412460_)"
    },
    d: " M-1394.9,704.1l5.6,9.6c0.4,0.7,1.1,1.1,2,1.1h11.1c0.8,0,1.6-0.4,2-1.1l5.6-9.6c0.4-0.7,0.4-1.6,0-2.3l-5.6-9.6 c-0.4-0.7-1.1-1.1-2-1.1h-11.1c-0.8,0-1.6,0.4-2,1.1l-5.6,9.6C-1395.3,702.5-1395.3,703.4-1394.9,704.1z M-1392.4,701.8l4.3-7.4 c0.4-0.7,1.1-1.1,2-1.1h8.6c0.8,0,1.6,0.4,2,1.1l4.3,7.4c0.4,0.7,0.4,1.6,0,2.3l-4.3,7.4c-0.4,0.7-1.1,1.1-2,1.1h-8.6 c-0.8,0-1.6-0.4-2-1.1l-4.3-7.4C-1392.8,703.4-1392.8,702.5-1392.4,701.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165947221963966603380000010388397470089162626_",
    gradientUnits: "userSpaceOnUse",
    x1: 2657.4475,
    y1: -621.0928,
    x2: 2684.2407,
    y2: -621.0928,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000165947221963966603380000010388397470089162626_)"
    },
    d: " M-1428.9,638.1l5.6,9.6c0.4,0.7,1.1,1.1,2,1.1h11.1c0.8,0,1.6-0.4,2-1.1l5.6-9.6c0.4-0.7,0.4-1.6,0-2.3l-5.6-9.6 c-0.4-0.7-1.1-1.1-2-1.1h-11.1c-0.8,0-1.6,0.4-2,1.1l-5.6,9.6C-1429.3,636.5-1429.3,637.4-1428.9,638.1z M-1426.4,635.8l4.3-7.4 c0.4-0.7,1.1-1.1,2-1.1h8.6c0.8,0,1.6,0.4,2,1.1l4.3,7.4c0.4,0.7,0.4,1.6,0,2.3l-4.3,7.4c-0.4,0.7-1.1,1.1-2,1.1h-8.6 c-0.8,0-1.6-0.4-2-1.1l-4.3-7.4C-1426.8,637.4-1426.8,636.5-1426.4,635.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134929728453334222590000002141250293192613811_",
    gradientUnits: "userSpaceOnUse",
    x1: 2657.4475,
    y1: -711.0928,
    x2: 2684.2407,
    y2: -711.0928,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000134929728453334222590000002141250293192613811_)"
    },
    d: " M-1428.9,728.1l5.6,9.6c0.4,0.7,1.1,1.1,2,1.1h11.1c0.8,0,1.6-0.4,2-1.1l5.6-9.6c0.4-0.7,0.4-1.6,0-2.3l-5.6-9.6 c-0.4-0.7-1.1-1.1-2-1.1h-11.1c-0.8,0-1.6,0.4-2,1.1l-5.6,9.6C-1429.3,726.5-1429.3,727.4-1428.9,728.1z M-1426.4,725.8l4.3-7.4 c0.4-0.7,1.1-1.1,2-1.1h8.6c0.8,0,1.6,0.4,2,1.1l4.3,7.4c0.4,0.7,0.4,1.6,0,2.3l-4.3,7.4c-0.4,0.7-1.1,1.1-2,1.1h-8.6 c-0.8,0-1.6-0.4-2-1.1l-4.3-7.4C-1426.8,727.4-1426.8,726.5-1426.4,725.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078044870444619972480000011098750034544459446_",
    gradientUnits: "userSpaceOnUse",
    x1: 2648.4475,
    y1: -617.0928,
    x2: 2675.2407,
    y2: -617.0928,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000078044870444619972480000011098750034544459446_)"
    },
    d: " M-1419.9,634.1l5.6,9.6c0.4,0.7,1.1,1.1,2,1.1h11.1c0.8,0,1.6-0.4,2-1.1l5.6-9.6c0.4-0.7,0.4-1.6,0-2.3l-5.6-9.6 c-0.4-0.7-1.1-1.1-2-1.1h-11.1c-0.8,0-1.6,0.4-2,1.1l-5.6,9.6C-1420.3,632.5-1420.3,633.4-1419.9,634.1z M-1417.4,631.8l4.3-7.4 c0.4-0.7,1.1-1.1,2-1.1h8.6c0.8,0,1.6,0.4,2,1.1l4.3,7.4c0.4,0.7,0.4,1.6,0,2.3l-4.3,7.4c-0.4,0.7-1.1,1.1-2,1.1h-8.6 c-0.8,0-1.6-0.4-2-1.1l-4.3-7.4C-1417.8,633.4-1417.8,632.5-1417.4,631.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059309813562867959910000014350557657127980980_",
    gradientUnits: "userSpaceOnUse",
    x1: -373.1253,
    y1: 87.4101,
    x2: -328.4475,
    y2: 87.4101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5938BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008396"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000059309813562867959910000014350557657127980980_)"
    },
    d: "M-328.8,83.5 l-7-12c-0.5-0.9-1.4-1.4-2.4-1.4h-13.9c-1,0-1.9,0.5-2.4,1.4l-2.1,3.6h-6.7c-1,0-1.9,0.5-2.4,1.4l-7,12c-0.5,0.9-0.5,1.9,0,2.8 l7,12c0.5,0.9,1.4,1.4,2.4,1.4h13.9c1,0,1.9-0.5,2.4-1.4l2.1-3.6h6.7c1,0,1.9-0.5,2.4-1.4l7-12C-328.3,85.5-328.3,84.4-328.8,83.5z  M-348.6,100.6c-0.5,0.9-1.4,1.4-2.4,1.4h-10.7c-1,0-1.9-0.5-2.4-1.4l-5.4-9.3c-0.5-0.9-0.5-1.9,0-2.8l5.4-9.3 c0.5-0.9,1.4-1.4,2.4-1.4h3.6l-3.3,5.7c-0.5,0.9-0.5,1.9,0,2.8l7,12c0.5,0.9,1.4,1.4,2.4,1.4h4L-348.6,100.6z M-355,77.8h4 c1,0,1.9,0.5,2.4,1.4l5.4,9.3c0.5,0.9,0.5,1.9,0,2.8l-3.3,5.7h-4c-1,0-1.9-0.5-2.4-1.4l-5.4-9.3c-0.5-0.9-0.5-1.9,0-2.8L-355,77.8z  M-332,86.3l-5.4,9.3c-0.5,0.9-1.4,1.4-2.4,1.4h-3.6l3.3-5.7c0.5-0.9,0.5-1.9,0-2.8l-7-12c-0.5-0.9-1.4-1.4-2.4-1.4h-4l0.5-0.8 c0.5-0.9,1.4-1.4,2.4-1.4h10.7c1,0,1.9,0.5,2.4,1.4l5.4,9.3C-331.5,84.4-331.5,85.5-332,86.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062157397586832930310000011134220163524252323_",
    gradientUnits: "userSpaceOnUse",
    x1: 2681.4475,
    y1: -591.0928,
    x2: 2708.2407,
    y2: -591.0928,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000062157397586832930310000011134220163524252323_)"
    },
    d: " M-1452.9,608.1l5.6,9.6c0.4,0.7,1.1,1.1,2,1.1h11.1c0.8,0,1.6-0.4,2-1.1l5.6-9.6c0.4-0.7,0.4-1.6,0-2.3l-5.6-9.6 c-0.4-0.7-1.1-1.1-2-1.1h-11.1c-0.8,0-1.6,0.4-2,1.1l-5.6,9.6C-1453.3,606.5-1453.3,607.4-1452.9,608.1z M-1450.4,605.8l4.3-7.4 c0.4-0.7,1.1-1.1,2-1.1h8.6c0.8,0,1.6,0.4,2,1.1l4.3,7.4c0.4,0.7,0.4,1.6,0,2.3l-4.3,7.4c-0.4,0.7-1.1,1.1-2,1.1h-8.6 c-0.8,0-1.6-0.4-2-1.1l-4.3-7.4C-1450.8,607.4-1450.8,606.5-1450.4,605.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167388460731667880750000000057107870924045479_",
    gradientUnits: "userSpaceOnUse",
    x1: 2670.4475,
    y1: -687.0928,
    x2: 2697.2407,
    y2: -687.0928,
    gradientTransform: "matrix(-1 0 0 -1 1255 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000167388460731667880750000000057107870924045479_)"
    },
    d: " M-1441.9,704.1l5.6,9.6c0.4,0.7,1.1,1.1,2,1.1h11.1c0.8,0,1.6-0.4,2-1.1l5.6-9.6c0.4-0.7,0.4-1.6,0-2.3l-5.6-9.6 c-0.4-0.7-1.1-1.1-2-1.1h-11.1c-0.8,0-1.6,0.4-2,1.1l-5.6,9.6C-1442.3,702.5-1442.3,703.4-1441.9,704.1z M-1439.4,701.8l4.3-7.4 c0.4-0.7,1.1-1.1,2-1.1h8.6c0.8,0,1.6,0.4,2,1.1l4.3,7.4c0.4,0.7,0.4,1.6,0,2.3l-4.3,7.4c-0.4,0.7-1.1,1.1-2,1.1h-8.6 c-0.8,0-1.6-0.4-2-1.1l-4.3-7.4C-1439.8,703.4-1439.8,702.5-1439.4,701.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119116521712184696370000017067500403165767850_",
    gradientUnits: "userSpaceOnUse",
    x1: -1039.2407,
    y1: 622.1986,
    x2: -946.6543,
    y2: 622.1986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000119116521712184696370000017067500403165767850_)"
    },
    d: "M-947.7,618.3 l-19.2-33.3c-1.4-2.4-4-3.9-6.8-3.9h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3c-1.4,2.4-1.4,5.4,0,7.8l19.2,33.3 c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3C-946.3,623.7-946.3,620.7-947.7,618.3z M-956.5,626.1l-14.9,25.7 c-1.4,2.4-4,3.9-6.8,3.9h-29.7c-2.8,0-5.4-1.5-6.8-3.9l-14.9-25.7c-1.4-2.4-1.4-5.4,0-7.8l14.9-25.7c1.4-2.4,4-3.9,6.8-3.9h29.7 c2.8,0,5.4,1.5,6.8,3.9l14.9,25.7C-955.1,620.7-955.1,623.7-956.5,626.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079445348795150230620000007885034265091410082_",
    gradientUnits: "userSpaceOnUse",
    x1: -1674.2407,
    y1: 487.1986,
    x2: -1581.6543,
    y2: 487.1986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000079445348795150230620000007885034265091410082_)"
    },
    d: " M-1582.7,483.3l-19.2-33.3c-1.4-2.4-4-3.9-6.8-3.9h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3c-1.4,2.4-1.4,5.4,0,7.8l19.2,33.3 c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3C-1581.3,488.7-1581.3,485.7-1582.7,483.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061473825702308741870000004418354271889434550_",
    gradientUnits: "userSpaceOnUse",
    x1: 2242.6543,
    y1: -383.3326,
    x2: 2335.2407,
    y2: -383.3326,
    gradientTransform: "matrix(-1 0 0 -1 1423 259.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000061473825702308741870000004418354271889434550_)"
    },
    d: "M-911.2,647.1 l19.2,33.3c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3c1.4-2.4,1.4-5.4,0-7.8l-19.2-33.3c-1.4-2.4-4-3.9-6.8-3.9 h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3C-912.6,641.7-912.6,644.7-911.2,647.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162314504425520539210000003472767511755549355_",
    gradientUnits: "userSpaceOnUse",
    x1: -894.2408,
    y1: 643.1986,
    x2: -801.6543,
    y2: 643.1986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000162314504425520539210000003472767511755549355_)"
    },
    d: "M-802.7,639.3 l-19.2-33.3c-1.4-2.4-4-3.9-6.8-3.9h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3c-1.4,2.4-1.4,5.4,0,7.8l19.2,33.3 c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3C-801.3,644.7-801.3,641.7-802.7,639.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039814397176121886430000015444279494721628294_",
    gradientUnits: "userSpaceOnUse",
    x1: 2012.6543,
    y1: -471.3326,
    x2: 2105.2407,
    y2: -471.3326,
    gradientTransform: "matrix(-1 0 0 -1 284 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000039814397176121886430000015444279494721628294_)"
    },
    d: " M-1820.2,491.1l19.2,33.3c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3c1.4-2.4,1.4-5.4,0-7.8l-19.2-33.3 c-1.4-2.4-4-3.9-6.8-3.9h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3C-1821.6,485.7-1821.6,488.7-1820.2,491.1z M-1811.4,483.3 l14.9-25.7c1.4-2.4,4-3.9,6.8-3.9h29.7c2.8,0,5.4,1.5,6.8,3.9l14.9,25.7c1.4,2.4,1.4,5.4,0,7.8l-14.9,25.7c-1.4,2.4-4,3.9-6.8,3.9 h-29.7c-2.8,0-5.4-1.5-6.8-3.9l-14.9-25.7C-1812.8,488.7-1812.8,485.7-1811.4,483.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008113661393809423540000013963524616769379989_",
    gradientUnits: "userSpaceOnUse",
    x1: 2035.6543,
    y1: -471.3326,
    x2: 2128.2407,
    y2: -471.3326,
    gradientTransform: "matrix(-1 0 0 -1 284 15.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000008113661393809423540000013963524616769379989_)"
    },
    d: " M-1843.2,491.1l19.2,33.3c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3c1.4-2.4,1.4-5.4,0-7.8l-19.2-33.3 c-1.4-2.4-4-3.9-6.8-3.9h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3C-1844.6,485.7-1844.6,488.7-1843.2,491.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147221728699194067210000015392139292184735360_",
    gradientUnits: "userSpaceOnUse",
    x1: -1808.0178,
    y1: 585.1986,
    x2: -1807.5178,
    y2: 585.1986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000147221728699194067210000015392139292184735360_)"
    },
    d: " M-1602.7,581.3l-19.2-33.3c-1.4-2.4-4-3.9-6.8-3.9h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3c-1.4,2.4-1.4,5.4,0,7.8l19.2,33.3 c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3C-1601.3,586.7-1601.3,583.7-1602.7,581.3z M-1611.5,589.1l-14.9,25.7 c-1.4,2.4-4,3.9-6.8,3.9h-29.7c-2.8,0-5.4-1.5-6.8-3.9l-14.9-25.7c-1.4-2.4-1.4-5.4,0-7.8l14.9-25.7c1.4-2.4,4-3.9,6.8-3.9h29.7 c2.8,0,5.4,1.5,6.8,3.9l14.9,25.7C-1610.1,583.7-1610.1,586.7-1611.5,589.1z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M-1530.7,665.1h-38.5c-2.8,0-5.4,1.5-6.8,3.9l-19.2,33.3c-1.4,2.4-1.4,5.4,0,7.8l19.2,33.3 c1.4,2.4,4,3.9,6.8,3.9h38.5c2.8,0,5.4-1.5,6.8-3.9l19.2-33.3c1.4-2.4,1.4-5.4,0-7.8l-19.2-33.3 C-1525.3,666.5-1527.9,665.1-1530.7,665.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M-1535.1,672.7h-29.7c-2.8,0-5.4,1.5-6.8,3.9l-14.9,25.7c-1.4,2.4-1.4,5.4,0,7.8l14.9,25.7 c1.4,2.4,4,3.9,6.8,3.9h29.7c2.8,0,5.4-1.5,6.8-3.9l14.9-25.7c1.4-2.4,1.4-5.4,0-7.8l-14.9-25.7 C-1529.7,674.1-1532.3,672.7-1535.1,672.7z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1423.7922 569.8163)",
    style: {
      display: "inline",
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "'Roboto-Regular'",
      fontSize: 27
    }
  }, "payment"), /*#__PURE__*/React.createElement("tspan", {
    x: 104.3,
    y: 0,
    style: {
      fontFamily: "'Roboto-Light'",
      fontSize: 27
    }
  }, "service")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070120005540856349140000008518050635353518236_",
    gradientUnits: "userSpaceOnUse",
    x1: -367.4296,
    y1: 19.8154,
    x2: -334.2588,
    y2: 47.649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000070120005540856349140000008518050635353518236_)"
    },
    d: "M-327.4,32.2 l-7.6-13.1c-0.5-0.9-1.6-1.5-2.7-1.5H-349h-3.7h-11.4c-1.1,0-2.1,0.6-2.7,1.5l-7.6,13.1c-0.5,0.9-0.5,2.1,0,3.1l7.6,13.1 c0.5,0.9,1.6,1.5,2.7,1.5h11.4h3.7h11.4c1.1,0,2.1-0.6,2.7-1.5l7.6-13.1C-326.8,34.3-326.8,33.1-327.4,32.2z M-365,45.4l-5.8-10.1 c-0.5-0.9-0.5-2.1,0-3.1l5.8-10.1c0.5-0.9,1.6-1.5,2.7-1.5h6.2l-6.7,11.6c-0.5,0.9-0.5,2.1,0,3.1l6.7,11.6h-6.2 C-363.5,46.9-364.5,46.3-365,45.4z M-351,46.9c-1.1,0-2.1-0.6-2.7-1.5l-5.8-10.1c-0.5-0.9-0.5-2.1,0-3.1l5.8-10.1 c0.5-0.9,1.6-1.5,2.7-1.5h0.3c1.1,0,2.1,0.6,2.7,1.5l5.8,10.1c0.5,0.9,0.5,2.1,0,3.1l-5.8,10.1c-0.5,0.9-1.6,1.5-2.7,1.5H-351z  M-330.8,35.3l-5.8,10.1c-0.5,0.9-1.6,1.5-2.7,1.5h-6.2l6.7-11.6c0.5-0.9,0.5-2.1,0-3.1l-6.7-11.6h6.2c1.1,0,2.1,0.6,2.7,1.5 l5.8,10.1C-330.3,33.1-330.3,34.3-330.8,35.3z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -314.2923 38.3163)",
    style: {
      display: "inline",
      fill: "#00A0C5",
      fontFamily: "'Roboto-Regular'",
      fontSize: 27
    }
  }, "payment"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -250.2923 50.3163)",
    style: {
      display: "inline",
      fill: "#00A0C5",
      fontFamily: "'Roboto-Light'",
      fontSize: 13
    }
  }, "service"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -314.2923 151.3163)",
    style: {
      display: "inline",
      fill: "#00A0C5",
      fontFamily: "'Roboto-Regular'",
      fontSize: 27
    }
  }, "invoice"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -270.2923 163.3163)",
    style: {
      display: "inline",
      fill: "#00A0C5",
      fontFamily: "'Roboto-Light'",
      fontSize: 13
    }
  }, "service"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -314.2923 93.3163)",
    style: {
      display: "inline",
      fill: "#00A0C5",
      fontFamily: "'Roboto-Regular'",
      fontSize: 27
    }
  }, "subscription"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -206.2923 106.3163)",
    style: {
      display: "inline",
      fill: "#00A0C5",
      fontFamily: "'Roboto-Light'",
      fontSize: 13
    }
  }, "service")), /*#__PURE__*/React.createElement("g", {
    id: "paymentservice",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091711509224593408700000010458065174812751028_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.377,
    y1: 30.1785,
    x2: 124.8957,
    y2: 114.5238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000091711509224593408700000010458065174812751028_)"
    },
    d: "M145.8,67.7 L122.9,28c-1.7-2.9-4.7-4.6-8-4.6H80.3H69H34.4c-3.3,0-6.4,1.8-8,4.6L3.5,67.7c-1.7,2.9-1.7,6.4,0,9.3l22.9,39.7 c1.7,2.9,4.7,4.6,8,4.6H69h11.3h34.5c3.3,0,6.4-1.8,8-4.6L145.8,77C147.5,74.1,147.5,70.6,145.8,67.7z M31.6,107.7L13.9,77 c-1.7-2.9-1.7-6.4,0-9.3l17.7-30.7c1.7-2.9,4.7-4.6,8-4.6h18.7L38,67.7c-1.7,2.9-1.7,6.4,0,9.3l20.4,35.3H39.7 C36.3,112.3,33.3,110.5,31.6,107.7z M74.2,112.3c-3.3,0-6.4-1.8-8-4.6L48.5,77c-1.7-2.9-1.7-6.4,0-9.3l17.7-30.7 c1.7-2.9,4.7-4.6,8-4.6h0.9c3.3,0,6.4,1.8,8,4.6l17.7,30.7c1.7,2.9,1.7,6.4,0,9.3l-17.7,30.7c-1.7,2.9-4.7,4.6-8,4.6H74.2z  M135.4,77l-17.7,30.7c-1.7,2.9-4.7,4.6-8,4.6H90.9L111.3,77c1.7-2.9,1.7-6.4,0-9.3L90.9,32.4h18.7c3.3,0,6.4,1.8,8,4.6l17.7,30.7 C137,70.6,137,74.1,135.4,77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160162096952343685130000004740920551387529358_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.3637,
    y1: 242.165,
    x2: 156.6602,
    y2: 361.5659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF247F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "url(#SVGID_00000160162096952343685130000004740920551387529358_)"
    },
    d: "M186.3,295.3 l-32.5-56.2c-2.3-4.1-6.7-6.6-11.4-6.6H93.5h-16H28.6c-4.7,0-9,2.5-11.4,6.6l-32.5,56.2c-2.3,4.1-2.3,9.1,0,13.2l32.5,56.2 c2.3,4.1,6.7,6.6,11.4,6.6h48.9h16h48.9c4.7,0,9-2.5,11.4-6.6l32.5-56.2C188.6,304.4,188.6,299.4,186.3,295.3z M24.6,351.8 l-25.1-43.4c-2.3-4.1-2.3-9.1,0-13.2l25.1-43.4c2.3-4.1,6.7-6.6,11.4-6.6h26.5l-28.9,50c-2.3,4.1-2.3,9.1,0,13.2l28.9,50H36 C31.3,358.4,27,355.9,24.6,351.8z M84.9,358.4c-4.7,0-9-2.5-11.4-6.6l-25.1-43.4c-2.3-4.1-2.3-9.1,0-13.2l25.1-43.4 c2.3-4.1,6.7-6.6,11.4-6.6h1.2c4.7,0,9,2.5,11.4,6.6l25.1,43.4c2.3,4.1,2.3,9.1,0,13.2l-25.1,43.4c-2.3,4.1-6.7,6.6-11.4,6.6H84.9z  M171.5,308.4l-25.1,43.4c-2.3,4.1-6.7,6.6-11.4,6.6h-26.5l28.9-50c2.3-4.1,2.3-9.1,0-13.2l-28.9-50H135c4.7,0,9,2.5,11.4,6.6 l25.1,43.4C173.8,299.4,173.8,304.4,171.5,308.4z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M252.3,299c0,6-1.4,10.8-4.1,14.4c-2.7,3.6-6.4,5.5-11.1,5.5c-4.8,0-8.5-1.5-11.2-4.5v18.9h-6.7V279h6.1 l0.3,4.3c2.7-3.4,6.5-5.1,11.4-5.1c4.7,0,8.4,1.8,11.2,5.3c2.7,3.5,4.1,8.5,4.1,14.8V299z M245.6,298.3c0-4.4-0.9-7.9-2.8-10.5 c-1.9-2.6-4.5-3.8-7.7-3.8c-4.1,0-7.1,1.8-9.1,5.4v18.7c2,3.6,5.1,5.4,9.2,5.4c3.2,0,5.8-1.3,7.7-3.8 C244.7,307.1,245.6,303.3,245.6,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M285,318.2c-0.4-0.8-0.7-2.1-0.9-4.1c-3.1,3.2-6.8,4.9-11.2,4.9c-3.9,0-7-1.1-9.5-3.3 c-2.5-2.2-3.7-5-3.7-8.3c0-4.1,1.6-7.2,4.7-9.5c3.1-2.3,7.5-3.4,13.1-3.4h6.5v-3.1c0-2.3-0.7-4.2-2.1-5.6 c-1.4-1.4-3.5-2.1-6.2-2.1c-2.4,0-4.4,0.6-6,1.8c-1.6,1.2-2.4,2.7-2.4,4.4h-6.7c0-2,0.7-3.8,2.1-5.7c1.4-1.8,3.3-3.3,5.7-4.3 c2.4-1.1,5-1.6,7.8-1.6c4.5,0,8.1,1.1,10.6,3.4c2.6,2.3,3.9,5.4,4,9.3v18c0,3.6,0.5,6.5,1.4,8.6v0.6H285z M273.9,313.1 c2.1,0,4.1-0.5,6-1.6c1.9-1.1,3.2-2.5,4.1-4.2v-8h-5.3c-8.2,0-12.3,2.4-12.3,7.2c0,2.1,0.7,3.7,2.1,4.9 C269.9,312.5,271.7,313.1,273.9,313.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M314,308.4l9.1-29.4h7.2l-15.8,45.2c-2.4,6.5-6.3,9.8-11.6,9.8l-1.3-0.1l-2.5-0.5V328l1.8,0.1 c2.3,0,4-0.5,5.3-1.4c1.3-0.9,2.3-2.6,3.1-5l1.5-4l-14-38.8h7.3L314,308.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M342.6,279l0.2,4.3c2.9-3.4,6.8-5.1,11.6-5.1c5.5,0,9.2,2.1,11.2,6.3c1.3-1.9,3-3.4,5.1-4.6 c2.1-1.2,4.6-1.7,7.4-1.7c8.6,0,13,4.6,13.1,13.7v26.3h-6.7v-25.9c0-2.8-0.6-4.9-1.9-6.3c-1.3-1.4-3.4-2.1-6.4-2.1 c-2.5,0-4.6,0.7-6.2,2.2c-1.6,1.5-2.6,3.5-2.9,6v26h-6.7v-25.7c0-5.7-2.8-8.5-8.4-8.5c-4.4,0-7.4,1.9-9,5.6v28.6h-6.7V279H342.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M417.6,318.9c-5.3,0-9.6-1.7-13-5.2c-3.3-3.5-5-8.2-5-14v-1.2c0-3.9,0.7-7.4,2.2-10.4 c1.5-3.1,3.6-5.4,6.2-7.2c2.7-1.7,5.6-2.6,8.7-2.6c5.1,0,9.1,1.7,11.9,5c2.8,3.4,4.2,8.2,4.2,14.4v2.8h-26.5 c0.1,3.9,1.2,7,3.4,9.4c2.2,2.4,4.9,3.6,8.2,3.6c2.4,0,4.4-0.5,6-1.4c1.6-1,3.1-2.2,4.3-3.8l4.1,3.2 C429.1,316.4,424.1,318.9,417.6,318.9z M416.7,283.8c-2.7,0-5,1-6.8,3c-1.8,2-3,4.7-3.4,8.3h19.6v-0.5c-0.2-3.4-1.1-6-2.8-7.9 C421.8,284.7,419.5,283.8,416.7,283.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M447,279l0.2,4.9c3-3.8,6.9-5.7,11.7-5.7c8.3,0,12.5,4.7,12.5,14v25.9h-6.7v-25.9c0-2.8-0.7-4.9-1.9-6.3 c-1.3-1.3-3.2-2-5.9-2c-2.2,0-4.1,0.6-5.7,1.7s-2.9,2.7-3.8,4.6v27.9h-6.7V279H447z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M490.6,269.5v9.5h7.3v5.2h-7.3v24.3c0,1.6,0.3,2.8,1,3.5c0.7,0.8,1.8,1.2,3.3,1.2c0.8,0,1.8-0.1,3.2-0.4v5.4 c-1.8,0.5-3.5,0.7-5.1,0.7c-3,0-5.3-0.9-6.8-2.7c-1.5-1.8-2.3-4.4-2.3-7.7v-24.3h-7.1V279h7.1v-9.5H490.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M404,346.4c0-1-0.4-1.9-1.2-2.5c-0.8-0.6-2.1-1.1-3.8-1.5c-1.7-0.4-3-0.8-3.9-1.2c-0.9-0.5-1.6-1-2.1-1.7 c-0.4-0.7-0.7-1.5-0.7-2.4c0-1.5,0.6-2.7,1.9-3.7c1.2-1,2.8-1.5,4.8-1.5c2.1,0,3.8,0.5,5.1,1.6c1.3,1,1.9,2.4,1.9,4.1h-2.1 c0-1.1-0.5-2-1.4-2.8c-0.9-0.7-2.1-1.1-3.5-1.1c-1.4,0-2.5,0.3-3.3,0.9c-0.8,0.6-1.2,1.4-1.2,2.4c0,0.9,0.3,1.7,1,2.2s2,1,3.8,1.4 c1.8,0.4,3.2,0.9,4.1,1.4c0.9,0.5,1.6,1.1,2,1.8c0.4,0.7,0.7,1.5,0.7,2.5c0,1.6-0.6,2.9-1.9,3.8s-3,1.4-5,1.4 c-2.2,0-4-0.5-5.3-1.6c-1.4-1.1-2-2.4-2-4h2.1c0.1,1.2,0.6,2.2,1.5,2.9c0.9,0.7,2.2,1,3.8,1c1.5,0,2.6-0.3,3.5-1 C403.6,348.1,404,347.3,404,346.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M418.1,351.5c-1.6,0-3.1-0.4-4.4-1.2s-2.3-1.9-3-3.3c-0.7-1.4-1.1-3-1.1-4.8v-0.7c0-1.8,0.4-3.4,1.1-4.9 c0.7-1.5,1.7-2.6,2.9-3.4s2.6-1.2,4.1-1.2c2.3,0,4.1,0.8,5.5,2.3c1.3,1.6,2,3.7,2,6.4v1.2h-13.5v0.4c0,2.1,0.6,3.9,1.8,5.3 s2.8,2.1,4.6,2.1c1.1,0,2.1-0.2,3-0.6c0.9-0.4,1.6-1.1,2.3-2l1.3,1C423.3,350.4,421,351.5,418.1,351.5z M417.7,333.7 c-1.6,0-2.9,0.6-4,1.7c-1.1,1.1-1.7,2.7-2,4.6h11.3v-0.2c-0.1-1.8-0.6-3.3-1.6-4.4C420.6,334.3,419.3,333.7,417.7,333.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M438,334.1c-0.4-0.1-0.9-0.1-1.4-0.1c-1.3,0-2.4,0.4-3.3,1.1c-0.9,0.7-1.5,1.8-1.9,3.2v13h-2.1v-18.9h2l0,3 c1.1-2.2,2.9-3.3,5.3-3.3c0.6,0,1,0.1,1.4,0.2L438,334.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M447.5,348.3l5.7-16h2.1l-7,18.9h-1.7l-7.1-18.9h2.1L447.5,348.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M458.6,326.8c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1 c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1.1,0.4c-0.4,0-0.8-0.1-1-0.4C458.8,327.6,458.6,327.2,458.6,326.8z M461.1,351.2H459 v-18.9h2.1V351.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M473.7,349.7c1.5,0,2.7-0.4,3.7-1.2c1-0.8,1.5-1.9,1.6-3.2h2c-0.1,1.2-0.4,2.2-1.1,3.1 c-0.7,0.9-1.5,1.7-2.6,2.2c-1.1,0.5-2.3,0.8-3.5,0.8c-2.5,0-4.4-0.9-5.9-2.6c-1.4-1.7-2.2-4-2.2-6.9v-0.6c0-1.9,0.3-3.5,1-4.9 c0.7-1.4,1.6-2.5,2.8-3.3c1.2-0.8,2.6-1.2,4.3-1.2c2.1,0,3.8,0.6,5.1,1.8c1.3,1.2,2.1,2.9,2.2,4.9h-2c-0.1-1.5-0.6-2.7-1.6-3.6 c-1-0.9-2.2-1.4-3.7-1.4c-1.9,0-3.3,0.7-4.4,2c-1,1.4-1.6,3.3-1.6,5.7v0.6c0,2.4,0.5,4.3,1.6,5.6 C470.4,349.1,471.8,349.7,473.7,349.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M492.5,351.5c-1.6,0-3.1-0.4-4.4-1.2s-2.3-1.9-3-3.3c-0.7-1.4-1.1-3-1.1-4.8v-0.7c0-1.8,0.4-3.4,1.1-4.9 c0.7-1.5,1.7-2.6,2.9-3.4s2.6-1.2,4.1-1.2c2.3,0,4.1,0.8,5.5,2.3c1.3,1.6,2,3.7,2,6.4v1.2h-13.5v0.4c0,2.1,0.6,3.9,1.8,5.3 s2.8,2.1,4.6,2.1c1.1,0,2.1-0.2,3-0.6c0.9-0.4,1.6-1.1,2.3-2l1.3,1C497.6,350.4,495.4,351.5,492.5,351.5z M492.1,333.7 c-1.6,0-2.9,0.6-4,1.7c-1.1,1.1-1.7,2.7-2,4.6h11.3v-0.2c-0.1-1.8-0.6-3.3-1.6-4.4C495,334.3,493.7,333.7,492.1,333.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "invoice",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115500470561364502010000011243165159835481011_",
    gradientUnits: "userSpaceOnUse",
    x1: 487.8144,
    y1: 809.2183,
    x2: 410.7163,
    y2: 675.6805,
    gradientTransform: "matrix(0 1 -1 0 817.0858 -376.9142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BDB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2197"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.8,
      fill: "url(#SVGID_00000115500470561364502010000011243165159835481011_)"
    },
    d: "M74.6,126.1 l12.1,7c3.2,1.9,7.2,1.9,10.5,0l44.7-25.8c3.2-1.9,5.2-5.3,5.2-9.1V46.5c0-3.7-2-7.2-5.2-9.1L97.2,11.7c-3.2-1.9-7.2-1.9-10.5,0 l-12.1,7l-12.1-7c-3.2-1.9-7.2-1.9-10.5,0L7.4,37.5c-3.2,1.9-5.2,5.3-5.2,9.1v51.6c0,3.7,2,7.2,5.2,9.1l44.7,25.8 c3.2,1.9,7.2,1.9,10.5,0L74.6,126.1z M86.7,23.4c3.2-1.9,7.2-1.9,10.5,0l34.5,19.9c3.2,1.9,5.2,5.3,5.2,9.1v39.9 c0,3.7-2,7.2-5.2,9.1l-34.5,19.9c-3.2,1.9-7.2,1.9-10.5,0l-1.9-1.1l22.4-13c3.2-1.9,5.2-5.3,5.2-9.1V46.5c0-3.7-2-7.2-5.2-9.1 l-22.4-13L86.7,23.4z M74.6,114.3l-22.4-13C49,99.5,47,96,47,92.3V52.4c0-3.7,2-7.2,5.2-9.1l22.4-13l22.4,13 c3.2,1.9,5.2,5.3,5.2,9.1v39.9c0,3.7-2,7.2-5.2,9.1L74.6,114.3z M52.1,121.3l-34.5-19.9c-3.2-1.9-5.2-5.3-5.2-9.1V52.4 c0-3.7,2-7.2,5.2-9.1l34.5-19.9c3.2-1.9,7.2-1.9,10.5,0l1.9,1.1L42,37.5c-3.2,1.9-5.2,5.3-5.2,9.1v51.6c0,3.7,2,7.2,5.2,9.1 l22.4,13l-1.9,1.1C59.3,123.1,55.3,123.1,52.1,121.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133510490753684063410000018417666790133574018_",
    gradientUnits: "userSpaceOnUse",
    x1: 649.3422,
    y1: 1095.0649,
    x2: 585.1371,
    y2: 983.8585,
    gradientTransform: "matrix(0 1 -1 0 817.0858 -376.9142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BDB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2197"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.8,
      fill: "url(#SVGID_00000133510490753684063410000018417666790133574018_)"
    },
    d: "M-222.4,285.1 l10.1,5.8c2.7,1.6,6,1.6,8.7,0l37.2-21.5c2.7-1.6,4.4-4.4,4.4-7.5v-43c0-3.1-1.7-6-4.4-7.5l-37.2-21.5c-2.7-1.6-6-1.6-8.7,0 l-10.1,5.8l-10.1-5.8c-2.7-1.6-6-1.6-8.7,0l-37.2,21.5c-2.7,1.6-4.4,4.4-4.4,7.5v43c0,3.1,1.7,6,4.4,7.5l37.2,21.5 c2.7,1.6,6,1.6,8.7,0L-222.4,285.1z M-212.3,199.6c2.7-1.6,6-1.6,8.7,0l28.7,16.6c2.7,1.6,4.4,4.4,4.4,7.5v33.2 c0,3.1-1.7,6-4.4,7.5l-28.7,16.6c-2.7,1.6-6,1.6-8.7,0l-1.6-0.9l18.7-10.8c2.7-1.6,4.4-4.4,4.4-7.5v-43c0-3.1-1.7-6-4.4-7.5 l-18.7-10.8L-212.3,199.6z M-222.4,275.3l-18.7-10.8c-2.7-1.6-4.4-4.4-4.4-7.5v-33.2c0-3.1,1.7-6,4.4-7.5l18.7-10.8l18.7,10.8 c2.7,1.6,4.4,4.4,4.4,7.5v33.2c0,3.1-1.7,6-4.4,7.5L-222.4,275.3z M-241.2,281.1l-28.7-16.6c-2.7-1.6-4.4-4.4-4.4-7.5v-33.2 c0-3.1,1.7-6,4.4-7.5l28.7-16.6c2.7-1.6,6-1.6,8.7,0l1.6,0.9l-18.7,10.8c-2.7,1.6-4.4,4.4-4.4,7.5v43c0,3.1,1.7,6,4.4,7.5 l18.7,10.8l-1.6,0.9C-235.1,282.6-238.5,282.6-241.2,281.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039839654311974915790000007131143761378886558_",
    gradientUnits: "userSpaceOnUse",
    x1: 721.3271,
    y1: 801.5536,
    x2: 636.7905,
    y2: 655.1317,
    gradientTransform: "matrix(0 1 -1 0 817.0858 -376.9142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BDB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2197"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.8,
      fill: "url(#SVGID_00000039839654311974915790000007131143761378886558_)"
    },
    d: "M88.7,361.1 l13.3,7.7c3.6,2,7.9,2,11.5,0l49-28.3c3.6-2,5.7-5.8,5.7-9.9v-56.6c0-4.1-2.2-7.9-5.7-9.9l-49-28.3c-3.6-2-7.9-2-11.5,0l-13.3,7.7 l-13.3-7.7c-3.6-2-7.9-2-11.5,0l-49,28.3c-3.6,2-5.7,5.8-5.7,9.9v56.6c0,4.1,2.2,7.9,5.7,9.9l49,28.3c3.6,2,7.9,2,11.5,0 L88.7,361.1z M102,248.5c3.6-2,7.9-2,11.5,0l37.9,21.9c3.6,2,5.7,5.8,5.7,9.9V324c0,4.1-2.2,7.9-5.7,9.9l-37.9,21.9 c-3.6,2-7.9,2-11.5,0l-2.1-1.2l24.6-14.2c3.6-2,5.7-5.8,5.7-9.9v-56.6c0-4.1-2.2-7.9-5.7-9.9l-24.6-14.2L102,248.5z M88.7,348.1 l-24.6-14.2c-3.6-2-5.7-5.8-5.7-9.9v-43.7c0-4.1,2.2-7.9,5.7-9.9l24.6-14.2l24.6,14.2c3.6,2,5.7,5.8,5.7,9.9V324 c0,4.1-2.2,7.9-5.7,9.9L88.7,348.1z M64,355.8l-37.9-21.9c-3.6-2-5.7-5.8-5.7-9.9v-43.7c0-4.1,2.2-7.9,5.7-9.9L64,248.5 c3.6-2,7.9-2,11.5,0l2.1,1.2L53,263.9c-3.6,2-5.7,5.8-5.7,9.9v56.6c0,4.1,2.2,7.9,5.7,9.9l24.6,14.2l-2.1,1.2 C71.9,357.8,67.6,357.8,64,355.8z"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M203.3,268.8c0-1.1,0.3-2,1-2.8c0.7-0.7,1.7-1.1,3-1.1s2.3,0.4,3,1.1c0.7,0.8,1,1.7,1,2.8c0,1.1-0.3,2-1,2.7 c-0.7,0.7-1.7,1.1-3,1.1s-2.3-0.4-3-1.1C203.6,270.8,203.3,269.8,203.3,268.8z M210.5,318.4h-6.7v-39.3h6.7V318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M227.6,279.2l0.2,4.9c3-3.8,6.9-5.7,11.8-5.7c8.3,0,12.5,4.7,12.6,14v25.9h-6.7v-26c0-2.8-0.7-4.9-1.9-6.3 c-1.3-1.4-3.2-2-5.9-2c-2.2,0-4.1,0.6-5.7,1.7c-1.6,1.2-2.9,2.7-3.8,4.6v28h-6.7v-39.3H227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M275.2,309.3l9.7-30.2h6.9l-14.1,39.3h-5.1l-14.2-39.3h6.9L275.2,309.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M295.9,298.4c0-3.8,0.8-7.3,2.3-10.4c1.5-3.1,3.6-5.4,6.3-7.1c2.7-1.7,5.8-2.5,9.2-2.5c5.3,0,9.7,1.9,13,5.6 c3.3,3.7,5,8.6,5,14.8v0.5c0,3.8-0.7,7.3-2.2,10.3c-1.5,3-3.6,5.4-6.3,7.1c-2.7,1.7-5.8,2.5-9.4,2.5c-5.3,0-9.6-1.8-12.9-5.6 c-3.3-3.7-5-8.6-5-14.7V298.4z M302.7,299.2c0,4.4,1,7.9,3,10.5c2,2.6,4.7,4,8.1,4c3.4,0,6.1-1.3,8.1-4c2-2.7,3-6.4,3-11.2 c0-4.3-1-7.8-3.1-10.5c-2-2.7-4.8-4-8.1-4c-3.3,0-6,1.3-8,4C303.7,290.6,302.7,294.3,302.7,299.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M340.1,268.8c0-1.1,0.3-2,1-2.8c0.7-0.7,1.7-1.1,3-1.1c1.3,0,2.3,0.4,3,1.1c0.7,0.8,1,1.7,1,2.8 c0,1.1-0.3,2-1,2.7c-0.7,0.7-1.7,1.1-3,1.1c-1.3,0-2.3-0.4-3-1.1C340.5,270.8,340.1,269.8,340.1,268.8z M347.4,318.4h-6.7v-39.3 h6.7V318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M373.9,313.7c2.4,0,4.5-0.7,6.3-2.2c1.8-1.5,2.8-3.3,3-5.4h6.3c-0.1,2.3-0.9,4.4-2.3,6.4s-3.3,3.7-5.7,4.9 c-2.4,1.2-4.9,1.8-7.6,1.8c-5.3,0-9.6-1.8-12.8-5.4c-3.2-3.6-4.7-8.4-4.7-14.6V298c0-3.8,0.7-7.2,2.1-10.2c1.4-3,3.4-5.3,6-6.9 c2.6-1.6,5.7-2.5,9.3-2.5c4.4,0,8.1,1.3,11,4c2.9,2.6,4.5,6.1,4.7,10.3h-6.3c-0.2-2.5-1.2-4.6-2.9-6.3c-1.7-1.6-3.9-2.4-6.4-2.4 c-3.4,0-6.1,1.2-7.9,3.7c-1.9,2.5-2.8,6-2.8,10.7v1.3c0,4.5,0.9,8,2.8,10.4C367.8,312.5,370.4,313.7,373.9,313.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M413.3,319.2c-5.3,0-9.7-1.7-13-5.2c-3.3-3.5-5-8.2-5-14v-1.2c0-3.9,0.7-7.4,2.2-10.4 c1.5-3.1,3.6-5.5,6.2-7.2c2.7-1.7,5.6-2.6,8.7-2.6c5.1,0,9.1,1.7,11.9,5c2.8,3.4,4.2,8.2,4.2,14.4v2.8H402c0.1,3.9,1.2,7,3.4,9.4 c2.2,2.4,4.9,3.6,8.3,3.6c2.4,0,4.4-0.5,6-1.5c1.6-1,3.1-2.3,4.3-3.8l4.1,3.2C424.8,316.6,419.9,319.2,413.3,319.2z M412.5,284 c-2.7,0-5,1-6.8,3c-1.8,2-3,4.7-3.4,8.3h19.7v-0.5c-0.2-3.4-1.1-6.1-2.8-7.9C417.5,284.9,415.3,284,412.5,284z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M333.3,346.6c0-1-0.4-1.9-1.2-2.5c-0.8-0.6-2.1-1.1-3.8-1.5c-1.7-0.4-3-0.8-3.9-1.2c-0.9-0.5-1.6-1-2.1-1.7 c-0.4-0.7-0.7-1.5-0.7-2.4c0-1.5,0.6-2.7,1.9-3.7s2.8-1.5,4.8-1.5c2.1,0,3.8,0.5,5.1,1.6c1.3,1,1.9,2.4,1.9,4.1h-2.1 c0-1.1-0.5-2-1.4-2.8c-0.9-0.7-2.1-1.1-3.5-1.1c-1.4,0-2.5,0.3-3.3,0.9c-0.8,0.6-1.2,1.4-1.2,2.4c0,0.9,0.3,1.7,1,2.2 c0.7,0.5,2,1,3.8,1.4c1.8,0.4,3.2,0.9,4.1,1.4s1.6,1.1,2,1.8s0.7,1.5,0.7,2.5c0,1.6-0.6,2.9-1.9,3.8s-3,1.4-5,1.4 c-2.2,0-4-0.5-5.4-1.6c-1.4-1.1-2.1-2.4-2.1-4h2.1c0.1,1.2,0.6,2.2,1.5,2.9c0.9,0.7,2.2,1,3.8,1c1.5,0,2.6-0.3,3.5-1 C332.8,348.4,333.3,347.6,333.3,346.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M347.4,351.8c-1.6,0-3.1-0.4-4.4-1.2c-1.3-0.8-2.3-1.9-3-3.3c-0.7-1.4-1.1-3-1.1-4.8v-0.7 c0-1.8,0.4-3.5,1.1-4.9s1.7-2.6,2.9-3.4s2.6-1.2,4.1-1.2c2.3,0,4.1,0.8,5.5,2.3c1.3,1.6,2,3.7,2,6.4v1.2H341v0.4 c0,2.1,0.6,3.9,1.8,5.4c1.2,1.4,2.8,2.1,4.6,2.1c1.1,0,2.1-0.2,3-0.6c0.9-0.4,1.6-1.1,2.3-2l1.3,1 C352.6,350.7,350.3,351.8,347.4,351.8z M347,334c-1.6,0-2.9,0.6-4,1.7c-1.1,1.2-1.7,2.7-2,4.6h11.3v-0.2c-0.1-1.8-0.6-3.3-1.6-4.4 C349.9,334.6,348.6,334,347,334z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M367.3,334.3c-0.4-0.1-0.9-0.1-1.4-0.1c-1.3,0-2.4,0.4-3.3,1.1s-1.5,1.8-1.9,3.2v13h-2.1v-18.9h2l0,3 c1.1-2.2,2.9-3.4,5.3-3.4c0.6,0,1,0.1,1.4,0.2L367.3,334.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M376.8,348.6l5.7-16h2.1l-7.1,18.9H376l-7.1-18.9h2.1L376.8,348.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M388,327.1c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1 c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1.1,0.4c-0.4,0-0.8-0.1-1-0.4C388.1,327.8,388,327.5,388,327.1z M390.5,351.5h-2.1v-18.9 h2.1V351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M403.1,350c1.5,0,2.7-0.4,3.7-1.2c1-0.8,1.5-1.9,1.6-3.2h2c-0.1,1.2-0.4,2.2-1.1,3.2 c-0.7,0.9-1.5,1.7-2.6,2.2c-1.1,0.5-2.3,0.8-3.5,0.8c-2.5,0-4.4-0.9-5.9-2.6c-1.4-1.7-2.2-4-2.2-7v-0.6c0-1.9,0.3-3.5,1-4.9 c0.7-1.4,1.6-2.5,2.8-3.3c1.2-0.8,2.6-1.2,4.3-1.2c2.1,0,3.8,0.6,5.1,1.9c1.3,1.2,2.1,2.9,2.2,4.9h-2c-0.1-1.5-0.6-2.7-1.6-3.6 c-1-0.9-2.2-1.4-3.7-1.4c-1.9,0-3.4,0.7-4.4,2c-1,1.4-1.6,3.3-1.6,5.7v0.6c0,2.4,0.5,4.3,1.6,5.6C399.8,349.4,401.2,350,403.1,350 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M421.9,351.8c-1.6,0-3.1-0.4-4.4-1.2s-2.3-1.9-3-3.3c-0.7-1.4-1.1-3-1.1-4.8v-0.7c0-1.8,0.4-3.5,1.1-4.9 c0.7-1.5,1.7-2.6,2.9-3.4s2.6-1.2,4.1-1.2c2.3,0,4.1,0.8,5.5,2.3c1.3,1.6,2,3.7,2,6.4v1.2h-13.5v0.4c0,2.1,0.6,3.9,1.8,5.4 c1.2,1.4,2.8,2.1,4.6,2.1c1.1,0,2.1-0.2,3-0.6c0.9-0.4,1.6-1.1,2.3-2l1.3,1C427.1,350.7,424.8,351.8,421.9,351.8z M421.5,334 c-1.6,0-2.9,0.6-4,1.7c-1.1,1.2-1.7,2.7-2,4.6h11.3v-0.2c-0.1-1.8-0.6-3.3-1.6-4.4C424.4,334.6,423.1,334,421.5,334z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "agentservise"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179615408448136009530000011491006786912876952_",
    gradientUnits: "userSpaceOnUse",
    x1: -17.6388,
    y1: 302.7734,
    x2: 160.3811,
    y2: 302.7734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5938BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008396"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000179615408448136009530000011491006786912876952_)"
    },
    d: "M158.9,287.2l-27.7-48 c-2-3.5-5.7-5.6-9.7-5.6H66.1c-4,0-7.7,2.1-9.7,5.6l-8.2,14.3H21.3c-4,0-7.7,2.1-9.7,5.6l-27.7,48c-2,3.5-2,7.8,0,11.2l27.7,48 c2,3.5,5.7,5.6,9.7,5.6h55.4c4,0,7.7-2.1,9.7-5.6l8.2-14.3h26.8c4,0,7.7-2.1,9.7-5.6l27.7-48C160.9,295,160.9,290.7,158.9,287.2z  M80.1,355.4c-2,3.5-5.7,5.6-9.7,5.6H27.6c-4,0-7.7-2.1-9.7-5.6l-21.4-37c-2-3.5-2-7.8,0-11.2l21.4-37c2-3.5,5.7-5.6,9.7-5.6h14.2 l-13.1,22.8c-2,3.5-2,7.8,0,11.2l27.7,48c2,3.5,5.7,5.6,9.7,5.6h16L80.1,355.4z M54.4,264.5h16c4,0,7.7,2.1,9.7,5.6l21.4,37 c2,3.5,2,7.8,0,11.2l-13.1,22.8h-16c-4,0-7.7-2.1-9.7-5.6l-21.4-37c-2-3.5-2-7.8,0-11.2L54.4,264.5z M146.2,298.4l-21.4,37 c-2,3.5-5.7,5.6-9.7,5.6H101l13.1-22.8c2-3.5,2-7.8,0-11.2l-27.7-48c-2-3.5-5.7-5.6-9.7-5.6h-16l1.9-3.3c2-3.5,5.7-5.6,9.7-5.6 h42.8c4,0,7.7,2.1,9.7,5.6l21.4,37C148.3,290.7,148.3,295,146.2,298.4z"
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M213.2,307c0-1.7-0.7-3.1-2-4c-1.3-1-3.6-1.8-6.8-2.5c-3.3-0.7-5.8-1.5-7.7-2.5c-1.9-1-3.3-2.1-4.2-3.5 c-0.9-1.3-1.4-2.9-1.4-4.8c0-3.1,1.3-5.7,3.9-7.8c2.6-2.1,5.9-3.2,10-3.2c4.3,0,7.7,1.1,10.4,3.3c2.6,2.2,4,5,4,8.4h-6.5 c0-1.8-0.7-3.3-2.2-4.5c-1.5-1.3-3.4-1.9-5.6-1.9c-2.3,0-4.2,0.5-5.5,1.5c-1.3,1-2,2.4-2,4c0,1.6,0.6,2.7,1.8,3.5 c1.2,0.8,3.4,1.5,6.6,2.3c3.2,0.7,5.8,1.6,7.8,2.6c2,1,3.5,2.2,4.4,3.6c1,1.4,1.4,3.1,1.4,5.1c0,3.4-1.3,6-4,8.1 c-2.7,2-6.2,3-10.4,3c-3,0-5.7-0.5-8-1.6c-2.3-1.1-4.1-2.6-5.4-4.5c-1.3-1.9-2-4-2-6.2h6.4c0.1,2.2,1,3.9,2.6,5.1 c1.6,1.3,3.7,1.9,6.4,1.9c2.4,0,4.4-0.5,5.8-1.5C212.5,309.9,213.2,308.6,213.2,307z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M251.2,313.2c-2.5,2.9-6.2,4.4-11,4.4c-4,0-7.1-1.2-9.1-3.5c-2.1-2.3-3.2-5.8-3.2-10.3v-24.4h6.4v24.3 c0,5.7,2.3,8.5,6.9,8.5c4.9,0,8.2-1.8,9.8-5.5v-27.3h6.4v37.6h-6.1L251.2,313.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M299,298.6c0,5.7-1.3,10.4-4,13.8c-2.6,3.5-6.2,5.2-10.6,5.2c-4.7,0-8.4-1.7-11-5l-0.3,4.3h-5.9v-53.3h6.4 v19.9c2.6-3.2,6.2-4.8,10.7-4.8s8.1,1.7,10.7,5.2c2.6,3.5,3.9,8.2,3.9,14.2V298.6z M292.6,297.8c0-4.4-0.8-7.8-2.5-10.1 c-1.7-2.4-4.1-3.6-7.3-3.6c-4.2,0-7.3,2-9.1,5.9v16.2c2,3.9,5,5.9,9.2,5.9c3.1,0,5.5-1.2,7.2-3.6 C291.7,306.2,292.6,302.6,292.6,297.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M328.9,307c0-1.7-0.7-3.1-2-4c-1.3-1-3.6-1.8-6.8-2.5c-3.3-0.7-5.8-1.5-7.7-2.5c-1.9-1-3.3-2.1-4.2-3.5 c-0.9-1.3-1.4-2.9-1.4-4.8c0-3.1,1.3-5.7,3.9-7.8c2.6-2.1,5.9-3.2,10-3.2c4.3,0,7.7,1.1,10.4,3.3c2.6,2.2,4,5,4,8.4h-6.5 c0-1.8-0.7-3.3-2.2-4.5c-1.5-1.3-3.4-1.9-5.6-1.9c-2.3,0-4.2,0.5-5.5,1.5c-1.3,1-2,2.4-2,4c0,1.6,0.6,2.7,1.8,3.5 c1.2,0.8,3.4,1.5,6.6,2.3c3.2,0.7,5.8,1.6,7.8,2.6s3.5,2.2,4.4,3.6c1,1.4,1.4,3.1,1.4,5.1c0,3.4-1.3,6-4,8.1c-2.7,2-6.2,3-10.4,3 c-3,0-5.7-0.5-8-1.6c-2.3-1.1-4.1-2.6-5.4-4.5c-1.3-1.9-2-4-2-6.2h6.4c0.1,2.2,1,3.9,2.6,5.1c1.6,1.3,3.7,1.9,6.4,1.9 c2.4,0,4.4-0.5,5.8-1.5C328.2,309.9,328.9,308.6,328.9,307z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M358.8,312.4c2.3,0,4.3-0.7,6-2.1c1.7-1.4,2.7-3.1,2.8-5.2h6.1c-0.1,2.2-0.9,4.2-2.2,6.1s-3.2,3.5-5.5,4.7 c-2.3,1.2-4.7,1.7-7.2,1.7c-5.1,0-9.2-1.7-12.2-5.1c-3-3.4-4.5-8.1-4.5-14v-1.1c0-3.7,0.7-6.9,2-9.8c1.3-2.8,3.3-5.1,5.8-6.6 c2.5-1.6,5.5-2.4,8.9-2.4c4.2,0,7.7,1.3,10.5,3.8c2.8,2.5,4.3,5.8,4.5,9.8h-6.1c-0.2-2.4-1.1-4.4-2.8-6c-1.7-1.6-3.7-2.3-6.1-2.3 c-3.3,0-5.8,1.2-7.6,3.5c-1.8,2.4-2.7,5.7-2.7,10.2v1.2c0,4.3,0.9,7.7,2.7,10C352.9,311.2,355.5,312.4,358.8,312.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M399.1,285.1c-1-0.2-2-0.2-3.2-0.2c-4.2,0-7.1,1.8-8.6,5.4v26.7h-6.4v-37.6h6.2l0.1,4.3c2.1-3.4,5.1-5,9-5 c1.2,0,2.2,0.2,2.8,0.5V285.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M405,269.4c0-1,0.3-1.9,1-2.6c0.6-0.7,1.6-1.1,2.8-1.1c1.2,0,2.2,0.4,2.8,1.1c0.6,0.7,1,1.6,1,2.6 c0,1-0.3,1.9-1,2.6c-0.6,0.7-1.6,1-2.8,1c-1.2,0-2.2-0.3-2.8-1C405.3,271.3,405,270.5,405,269.4z M412,316.9h-6.4v-37.6h6.4V316.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M454,298.6c0,5.7-1.3,10.3-3.9,13.8c-2.6,3.5-6.2,5.2-10.6,5.2c-4.6,0-8.1-1.4-10.8-4.3v18.1h-6.4v-52h5.9 l0.3,4.2c2.6-3.2,6.2-4.9,10.9-4.9c4.5,0,8.1,1.7,10.7,5.1c2.6,3.4,3.9,8.1,3.9,14.2V298.6z M447.5,297.8c0-4.2-0.9-7.6-2.7-10 c-1.8-2.5-4.3-3.7-7.4-3.7c-3.9,0-6.8,1.7-8.7,5.2v17.9c1.9,3.4,4.9,5.1,8.8,5.1c3.1,0,5.5-1.2,7.3-3.7 C446.6,306.3,447.5,302.7,447.5,297.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M470.8,270.3v9.1h7v5h-7v23.3c0,1.5,0.3,2.6,0.9,3.4c0.6,0.8,1.7,1.1,3.2,1.1c0.7,0,1.8-0.1,3.1-0.4v5.2 c-1.7,0.5-3.3,0.7-4.9,0.7c-2.9,0-5-0.9-6.5-2.6c-1.5-1.7-2.2-4.2-2.2-7.4v-23.3h-6.8v-5h6.8v-9.1H470.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M485.4,269.4c0-1,0.3-1.9,1-2.6c0.6-0.7,1.6-1.1,2.8-1.1c1.2,0,2.2,0.4,2.8,1.1c0.6,0.7,1,1.6,1,2.6 c0,1-0.3,1.9-1,2.6s-1.6,1-2.8,1c-1.2,0-2.2-0.3-2.8-1C485.7,271.3,485.4,270.5,485.4,269.4z M492.3,316.9h-6.4v-37.6h6.4V316.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M500.9,297.8c0-3.7,0.7-7,2.2-9.9c1.4-2.9,3.5-5.2,6-6.8c2.6-1.6,5.5-2.4,8.8-2.4c5.1,0,9.3,1.8,12.4,5.3 c3.2,3.5,4.7,8.3,4.7,14.1v0.4c0,3.7-0.7,6.9-2.1,9.8c-1.4,2.9-3.4,5.2-6,6.8c-2.6,1.6-5.6,2.4-9,2.4c-5.1,0-9.2-1.8-12.4-5.3 c-3.2-3.5-4.7-8.2-4.7-14.1V297.8z M507.4,298.6c0,4.2,1,7.5,2.9,10c1.9,2.5,4.5,3.8,7.8,3.8c3.3,0,5.9-1.3,7.8-3.8 c1.9-2.6,2.9-6.1,2.9-10.7c0-4.1-1-7.5-2.9-10c-2-2.6-4.6-3.8-7.8-3.8c-3.2,0-5.7,1.3-7.7,3.8 C508.3,290.3,507.4,293.9,507.4,298.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M549.2,279.4l0.2,4.7c2.9-3.6,6.6-5.4,11.2-5.4c7.9,0,11.9,4.5,12,13.4v24.8h-6.4v-24.9c0-2.7-0.6-4.7-1.9-6 c-1.2-1.3-3.1-1.9-5.7-1.9c-2.1,0-3.9,0.6-5.5,1.7c-1.6,1.1-2.8,2.6-3.7,4.4v26.8h-6.4v-37.6H549.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M484.3,346.6c0-1-0.4-1.8-1.2-2.4c-0.8-0.6-2-1.1-3.6-1.4c-1.6-0.3-2.8-0.7-3.7-1.2c-0.9-0.4-1.5-1-2-1.6 c-0.4-0.6-0.6-1.4-0.6-2.3c0-1.4,0.6-2.6,1.8-3.5s2.7-1.4,4.6-1.4c2,0,3.6,0.5,4.9,1.5c1.2,1,1.8,2.3,1.8,3.9h-2 c0-1.1-0.4-1.9-1.3-2.6c-0.9-0.7-2-1.1-3.4-1.1c-1.3,0-2.4,0.3-3.2,0.9c-0.8,0.6-1.2,1.3-1.2,2.3c0,0.9,0.3,1.6,1,2.1 c0.7,0.5,1.9,1,3.6,1.4c1.8,0.4,3.1,0.9,3.9,1.3c0.9,0.5,1.5,1,1.9,1.7s0.6,1.5,0.6,2.4c0,1.5-0.6,2.7-1.8,3.7 c-1.2,0.9-2.8,1.4-4.8,1.4c-2.1,0-3.8-0.5-5.1-1.5c-1.3-1-2-2.3-2-3.9h2c0.1,1.2,0.6,2.1,1.5,2.7c0.9,0.7,2.1,1,3.6,1 c1.4,0,2.5-0.3,3.4-0.9C483.8,348.3,484.3,347.5,484.3,346.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M497.8,351.5c-1.5,0-2.9-0.4-4.2-1.1c-1.2-0.8-2.2-1.8-2.9-3.2c-0.7-1.4-1-2.9-1-4.6v-0.7 c0-1.7,0.3-3.3,1-4.7s1.6-2.5,2.8-3.3s2.5-1.2,3.9-1.2c2.2,0,3.9,0.7,5.2,2.2c1.3,1.5,1.9,3.5,1.9,6.1v1.1h-12.9v0.4 c0,2,0.6,3.8,1.8,5.1s2.7,2,4.4,2c1.1,0,2-0.2,2.8-0.6c0.8-0.4,1.6-1,2.2-1.9l1.3,1C502.7,350.4,500.6,351.5,497.8,351.5z  M497.4,334.5c-1.5,0-2.8,0.6-3.8,1.7c-1,1.1-1.7,2.6-1.9,4.4h10.8v-0.2c-0.1-1.7-0.6-3.2-1.5-4.2 C500.1,335,498.9,334.5,497.4,334.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M516.8,334.8c-0.4-0.1-0.9-0.1-1.4-0.1c-1.2,0-2.3,0.3-3.2,1c-0.9,0.7-1.5,1.7-1.8,3v12.4h-2v-18.1h2l0,2.9 c1.1-2.1,2.8-3.2,5.1-3.2c0.6,0,1,0.1,1.3,0.2L516.8,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M525.9,348.4l5.5-15.3h2.1l-6.8,18.1h-1.6l-6.8-18.1h2.1L525.9,348.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M536.6,327.9c0-0.4,0.1-0.7,0.4-1c0.2-0.3,0.6-0.4,1-0.4c0.4,0,0.8,0.1,1,0.4c0.2,0.3,0.4,0.6,0.4,1 c0,0.4-0.1,0.7-0.4,0.9c-0.3,0.3-0.6,0.4-1,0.4c-0.4,0-0.8-0.1-1-0.4C536.7,328.6,536.6,328.2,536.6,327.9z M539,351.2h-2v-18.1h2 V351.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M551.1,349.8c1.4,0,2.6-0.4,3.5-1.2c0.9-0.8,1.5-1.8,1.5-3h1.9c-0.1,1.1-0.4,2.1-1,3 c-0.6,0.9-1.5,1.6-2.5,2.1c-1.1,0.5-2.2,0.8-3.4,0.8c-2.4,0-4.3-0.8-5.6-2.5c-1.4-1.6-2.1-3.9-2.1-6.7v-0.6c0-1.8,0.3-3.4,0.9-4.7 c0.6-1.4,1.5-2.4,2.7-3.2c1.2-0.7,2.5-1.1,4.1-1.1c2,0,3.6,0.6,4.9,1.8c1.3,1.2,2,2.7,2.1,4.7h-1.9c-0.1-1.4-0.6-2.6-1.5-3.4 c-0.9-0.9-2.1-1.3-3.5-1.3c-1.8,0-3.2,0.7-4.2,2c-1,1.3-1.5,3.1-1.5,5.5v0.6c0,2.3,0.5,4.1,1.5,5.4 C547.9,349.2,549.3,349.8,551.1,349.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M569,351.5c-1.5,0-2.9-0.4-4.2-1.1s-2.2-1.8-2.9-3.2c-0.7-1.4-1-2.9-1-4.6v-0.7c0-1.7,0.3-3.3,1-4.7 c0.7-1.4,1.6-2.5,2.8-3.3c1.2-0.8,2.5-1.2,3.9-1.2c2.2,0,3.9,0.7,5.2,2.2c1.3,1.5,1.9,3.5,1.9,6.1v1.1h-12.9v0.4 c0,2,0.6,3.8,1.8,5.1s2.7,2,4.4,2c1.1,0,2-0.2,2.8-0.6c0.8-0.4,1.6-1,2.2-1.9l1.3,1C574,350.4,571.8,351.5,569,351.5z  M568.7,334.5c-1.5,0-2.8,0.6-3.8,1.7c-1,1.1-1.7,2.6-1.9,4.4h10.8v-0.2c-0.1-1.7-0.6-3.2-1.5-4.2 C571.4,335,570.2,334.5,568.7,334.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059288382826526639630000017241182020531984785_",
    gradientUnits: "userSpaceOnUse",
    x1: -273.9706,
    y1: 624.5,
    x2: -165.5653,
    y2: 624.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5938BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008396"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000059288382826526639630000017241182020531984785_)"
    },
    d: "M-166.6,620.5l-23.1-40.1 c-1.4-2.4-4-4-6.8-4h-46.3c-2.8,0-5.4,1.5-6.8,4l-23.1,40.1c-1.4,2.4-1.4,5.5,0,7.9l23.1,40.1c1.4,2.4,4,4,6.8,4h46.3 c2.8,0,5.4-1.5,6.8-4l23.1-40.1C-165.2,626-165.2,623-166.6,620.5z M-176.3,628.5l-18.3,31.7c-1.4,2.4-4,4-6.8,4h-36.6 c-2.8,0-5.4-1.5-6.8-4l-18.3-31.7c-1.4-2.4-1.4-5.5,0-7.9l18.3-31.7c1.4-2.4,4-4,6.8-4h36.6c2.8,0,5.4,1.5,6.8,4l18.3,31.7 C-174.9,623-174.9,626-176.3,628.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012433271052991919110000012818871100725840041_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.4187,
    y1: 72.3511,
    x2: 146.8541,
    y2: 72.3511
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5938BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008396"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000012433271052991919110000012818871100725840041_)"
    },
    d: "M145.7,59.6l-25.3-43.7 c-1.5-2.7-4.4-4.3-7.5-4.3H62.5c-3.1,0-5.9,1.6-7.5,4.3l-7.3,12.6H36.3c-3.1,0-5.9,1.6-7.5,4.3L3.6,76.5c-1.5,2.7-1.5,6,0,8.6 l25.3,43.7c1.5,2.7,4.4,4.3,7.5,4.3h50.5c3.1,0,5.9-1.6,7.5-4.3l7.3-12.6H113c3.1,0,5.9-1.6,7.5-4.3l25.3-43.7 C147.2,65.5,147.2,62.2,145.7,59.6z M89,119.7c-1.5,2.7-4.4,4.3-7.5,4.3H41.6c-3.1,0-5.9-1.6-7.5-4.3l-20-34.6 c-1.5-2.7-1.5-6,0-8.6l20-34.6c1.5-2.7,4.4-4.3,7.5-4.3h0.8L29.8,59.6c-1.5,2.7-1.5,6,0,8.6L55,111.9c1.5,2.7,4.4,4.3,7.5,4.3H91 L89,119.7z M53,37.6h28.5c3.1,0,5.9,1.6,7.5,4.3l20,34.6c1.5,2.7,1.5,6,0,8.6l-12.7,21.9H67.8c-3.1,0-5.9-1.6-7.5-4.3l-20-34.6 c-1.5-2.7-1.5-6,0-8.6L53,37.6z M135.1,68.2l-20,34.6c-1.5,2.7-4.4,4.3-7.5,4.3h-0.8l12.7-21.9c1.5-2.7,1.5-6,0-8.6L94.3,32.8 c-1.5-2.7-4.4-4.3-7.5-4.3H58.3l2-3.5c1.5-2.7,4.4-4.3,7.5-4.3h39.9c3.1,0,5.9,1.6,7.5,4.3l20,34.6 C136.6,62.2,136.6,65.5,135.1,68.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072975751930620995500000001408658062224490136_",
    gradientUnits: "userSpaceOnUse",
    x1: -142.9706,
    y1: 372.5,
    x2: -34.5653,
    y2: 372.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5938BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008396"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000072975751930620995500000001408658062224490136_)"
    },
    d: "M-35.6,368.5l-23.1-40.1 c-1.4-2.4-4-4-6.8-4h-46.3c-2.8,0-5.4,1.5-6.8,4l-23.1,40.1c-1.4,2.4-1.4,5.5,0,7.9l23.1,40.1c1.4,2.4,4,4,6.8,4h46.3 c2.8,0,5.4-1.5,6.8-4l23.1-40.1C-34.2,374-34.2,371-35.6,368.5z M-45.3,376.5l-18.3,31.7c-1.4,2.4-4,4-6.8,4h-36.6 c-2.8,0-5.4-1.5-6.8-4l-18.3-31.7c-1.4-2.4-1.4-5.5,0-7.9l18.3-31.7c1.4-2.4,4-4,6.8-4h36.6c2.8,0,5.4,1.5,6.8,4l18.3,31.7 C-43.9,371-43.9,374-45.3,376.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152247438520161708820000009795661035989910150_",
    gradientUnits: "userSpaceOnUse",
    x1: -125.9706,
    y1: 357.5,
    x2: -17.5653,
    y2: 357.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5938BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008396"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000152247438520161708820000009795661035989910150_)"
    },
    d: "M-18.6,353.5l-23.1-40.1 c-1.4-2.4-4-4-6.8-4h-46.3c-2.8,0-5.4,1.5-6.8,4l-23.1,40.1c-1.4,2.4-1.4,5.5,0,7.9l23.1,40.1c1.4,2.4,4,4,6.8,4h46.3 c2.8,0,5.4-1.5,6.8-4l23.1-40.1C-17.2,359-17.2,356-18.6,353.5z M-28.3,361.5l-18.3,31.7c-1.4,2.4-4,4-6.8,4h-36.6 c-2.8,0-5.4-1.5-6.8-4l-18.3-31.7c-1.4-2.4-1.4-5.5,0-7.9l18.3-31.7c1.4-2.4,4-4,6.8-4h36.6c2.8,0,5.4,1.5,6.8,4l18.3,31.7 C-26.9,356-26.9,359-28.3,361.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137832892472618160220000011071749674170212780_",
    gradientUnits: "userSpaceOnUse",
    x1: -250.9706,
    y1: 610.5,
    x2: -142.5653,
    y2: 610.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5938BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008396"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000137832892472618160220000011071749674170212780_)"
    },
    d: "M-143.6,606.5l-23.1-40.1 c-1.4-2.4-4-4-6.8-4h-46.3c-2.8,0-5.4,1.5-6.8,4l-23.1,40.1c-1.4,2.4-1.4,5.5,0,7.9l23.1,40.1c1.4,2.4,4,4,6.8,4h46.3 c2.8,0,5.4-1.5,6.8-4l23.1-40.1C-142.2,612-142.2,609-143.6,606.5z M-153.3,614.5l-18.3,31.7c-1.4,2.4-4,4-6.8,4h-36.6 c-2.8,0-5.4-1.5-6.8-4l-18.3-31.7c-1.4-2.4-1.4-5.5,0-7.9l18.3-31.7c1.4-2.4,4-4,6.8-4h36.6c2.8,0,5.4,1.5,6.8,4l18.3,31.7 C-151.9,609-151.9,612-153.3,614.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103245710499865835460000004764628579037602217_",
    gradientUnits: "userSpaceOnUse",
    x1: -285.8225,
    y1: 490.7683,
    x2: -177.4172,
    y2: 490.7683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5938BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008396"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000103245710499865835460000004764628579037602217_)"
    },
    d: "M-178.5,486.8l-23.1-40.1 c-1.4-2.4-4-4-6.8-4h-46.3c-2.8,0-5.4,1.5-6.8,4l-23.1,40.1c-1.4,2.4-1.4,5.5,0,7.9l23.1,40.1c1.4,2.4,4,4,6.8,4h46.3 c2.8,0,5.4-1.5,6.8-4l23.1-40.1C-177.1,492.3-177.1,489.3-178.5,486.8z M-188.2,494.7l-18.3,31.7c-1.4,2.4-4,4-6.8,4h-36.6 c-2.8,0-5.4-1.5-6.8-4l-18.3-31.7c-1.4-2.4-1.4-5.5,0-7.9l18.3-31.7c1.4-2.4,4-4,6.8-4h36.6c2.8,0,5.4,1.5,6.8,4l18.3,31.7 C-186.8,489.3-186.8,492.3-188.2,494.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016056184952731104460000007022880980237620363_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.8226,
    y1: 472.2683,
    x2: -148.8519,
    y2: 472.2683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5938BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008396"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000016056184952731104460000007022880980237620363_)"
    },
    d: "M-149.8,468.6l-21.1-37.2 c-1.3-2.3-3.7-3.7-6.3-3.7h-42.3c-2.6,0-5,1.4-6.3,3.7l-21.1,37.2c-1.3,2.3-1.3,5.1,0,7.3l21.1,37.2c1.3,2.3,3.7,3.7,6.3,3.7h42.3 c2.6,0,5-1.4,6.3-3.7l21.1-37.2C-148.5,473.7-148.5,470.9-149.8,468.6z M-158.7,475.9l-16.7,29.4c-1.3,2.3-3.7,3.7-6.3,3.7H-215 c-2.6,0-5-1.4-6.3-3.7l-16.7-29.4c-1.3-2.3-1.3-5.1,0-7.3l16.7-29.4c1.3-2.3,3.7-3.7,6.3-3.7h33.4c2.6,0,5,1.4,6.3,3.7l16.7,29.4 C-157.4,470.9-157.4,473.7-158.7,475.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/agent.94c56ca13b1aebbe5789c19678a217fd.svg";
export { ForwardRef as ReactComponent };